module.exports = {
	"es": {
		"moet-core": {
			"select_language": {
				"title": "Selecciona tu idioma",
				"paragraph": "Será tu idioma predeterminado",
				"submit": "De acuerdo"
			},
			"products": {
				"mandatory": "Siempre se incluye",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Ofrecer todos nuestros métodos de pago."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Pagar ahora"
							},
							"description": {
								"default": "Ofrecer pagos instantáneos con tarjeta o transferencia bancaria."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Pagar en 30 días"
							},
							"description": {
								"default": "Ofrecer pago en 30 días. Sin intereses."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Financiación"
							},
							"description": {
								"default": "Ofrecer pago entre 6-36 meses.",
								"DE": "Ofrecer pago entre 6-24 meses.",
								"AT": "Ofrecer pago entre 6-24 meses."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Paga en 3 plazos"
							},
							"description": {
								"default": "Ofrecer 3 plazos sin intereses.",
								"GB": "Ofrecer 3 plazos sin intereses."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Paga en 4 plazos",
								"US": "Plazos",
								"AU": "Pagar en 4 plazos"
							},
							"description": {
								"default": "Ofrecer 4 plazos sin intereses.",
								"GB": "Ofrecer 4 plazos sin intereses."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Formas de pago"
					},
					"description": {
						"default": "Elige entre nuestras soluciones de pago únicas. Elige una o combina varias. Integración fácil y en una sola vez para cualquier opción elegida."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Pagar ahora"
							},
							"description": {
								"default": "Ofrecer pagos instantáneos con tarjeta o transferencia bancaria."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Pagar en 30 días"
							},
							"description": {
								"default": "Ofrecer pago en 30 días. Sin intereses."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Financiación"
							},
							"description": {
								"default": "Ofrecer pago en más de 6-36 meses.",
								"DE": "Ofrecer pago en 6-24 meses.",
								"AT": "Ofrecer pago en 6-24 meses."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Paga en 3 plazos"
							},
							"description": {
								"default": "Ofrecer 3 plazos sin intereses.",
								"GB": "Ofrecer 3 plazos sin intereses."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Paga en 4 plazos",
								"US": "4 pagos",
								"CA": "4 plazos",
								"AU": "Pagar en 4 plazos"
							},
							"description": {
								"default": "Ofrecer 4 plazos sin intereses.",
								"GB": "Ofrecer 4 plazos sin intereses.",
								"US": "Los pedidos de 35 $ a 1000 $ se pueden dividir en 4 plazos sin intereses, con vencimiento cada 2 semanas.",
								"CA": "Los pedidos de 35 $ a 1000 $ se pueden dividir en 4 plazos sin intereses, con vencimiento cada 2 semanas."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Sustituye tu proceso de pago con el servicio completo de pagos de Klarna."
					},
					"description_expanded": {
						"default": "Sustituye tu proceso de pago con el servicio completo de pagos de Klarna."
					}
				},
				"kp_one": {
					"name": {
						"default": "Método de pago"
					},
					"description": {
						"default": "Añade los métodos de pago de Klarna a tu proceso"
					},
					"description_expanded": {
						"default": "Ofrecer los métodos de pago de Klarna lleva a un incremento del 30 % en las conversiones, un 41 % en el valor medio del pedido y un 36 % en la frecuencia de compra."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Este campo es obligatorio para continuar",
					"generic": "El valor introducido no es válido",
					"required_suffix": "es obligatorio para continuar",
					"generic_suffix": "no es válido",
					"min_one": "Debes seleccionar al menos un elemento",
					"min": "Debes seleccionar al menos {min} elementos",
					"max": "No puedes seleccionar más de {max} elementos",
					"given_name": "Falta el nombre",
					"family_name": {
						"general": "Falta el apellido",
						"too_short": "Indica un apellido válido"
					},
					"date_of_birth": {
						"general": {
							"default": "Indica una fecha de nacimiento válida (DD/MM/AAAA)",
							"US": "Indica una fecha de nacimiento válida (MM/DD/AAAA)"
						},
						"too_young": "Todos los accionistas deben ser mayores de 16 años",
						"too_young_eighteen": "Debes ser mayor de 18 años"
					},
					"street_address": "Indica una calle",
					"street_address2": "Indica una línea de dirección 2 válida",
					"postal_code": "Indica un código postal",
					"country": "Indica un país",
					"region": "Indica una región",
					"state": "Indica un estado",
					"iban": "Indica un número de cuenta (IBAN)",
					"companyName": "Indica un nombre de empresa",
					"email": "Indica un e-mail válido",
					"contact_email": "Indica un correo electrónico de contacto válido",
					"support_email": "Indica un correo electrónico de atención al cliente válido",
					"support_phone": "Indica un número de teléfono de asistencia válido",
					"selling_countries": "Debes seleccionar al menos un país",
					"store_category": "Debes seleccionar una de las opciones",
					"name": "Indica un número de tienda",
					"legal_form": "Elige uno de los tipos de empresa enumerados",
					"generic_toggle_undefined": "Selecciona una de las opciones",
					"website": "Indica una URL válida",
					"bankAccounts": "Indica al menos una cuenta bancaria",
					"product": "Selecciona un producto",
					"platform": "Selecciona una plataforma",
					"password": "Crea una contraseña segura",
					"currency_code": "Indica un código de moneda",
					"account_holder": "Indica un titular de cuenta bancaria",
					"account_type": "Indica un tipo de cuenta bancaria",
					"routing_number": "Indica un número de ruta válido",
					"account_number": {
						"first": "Indica un número de cuenta válido para la cuenta bancaria predeterminada",
						"second": "Indica un número de cuenta válido para la primera cuenta bancaria adicional",
						"third": "Indica un número de cuenta válido para la segunda cuenta bancaria adicional",
						"fourth": "Indica un número de cuenta válido para la tercera cuenta bancaria adicional",
						"general": "Indica un número de cuenta válido"
					},
					"role": "Indica una función",
					"address": "Indica una dirección",
					"political_exposed_person": "Facilita información sobre la persona expuesta políticamente (PEP)",
					"pep_position": "Facilita información sobre un cargo",
					"pep_relationship": "Facilita información sobre la relación con la PEP",
					"goodsCategory": "Indica la categoría de la mercancía",
					"registered": "Indica los datos de registro de tu empresa",
					"subjectToVat": "Indica tu NIF",
					"registrationCourt": "Indica un tribunal de registro",
					"registrationId": {
						"general": {
							"default": "Indica un número de registro válido",
							"AT": "Indica un número de registro válido",
							"AU": "Indica un ACN válido",
							"ES": "Introduce un NIF/NIE/DNI válido",
							"GB": "Indica un número de organización válido",
							"GR": "Introduce un número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.) válido",
							"CA": "Indica un número de empresa válido",
							"NZ": "Indica un número de empresa válido",
							"US": "Indica un Número de Identificación de Empresa válido"
						},
						"missing_leading_0_GB": "Indica un número de organización de 8 dígitos. Puede que a tu número de organización le falte un 0 inicial (por ej., 03452678)",
						"invalid": {
							"default": "Indica un número de registro válido",
							"AT": "El número de registro debe tener entre 5 y 11 caracteres. Este no es tu número de IVA ni tu ID de comerciante.",
							"AU": "El ACN debe tener 9 dígitos, sin espacios entre ellos. Por ej.: 123456789",
							"BE": "El número de registro debe tener 10 dígitos. Por ej.: 1234567890",
							"CA": "El número de empresa debe tener 9 dígitos. Por ej.: 123456789",
							"CZ": "El número de registro debe tener 8 dígitos. Por ej.: 12345678",
							"DE": "El número de registro debe tener entre 6 y 11 caracteres y comenzar con HRA, HRB, GnR, VR o PR, seguido de un espacio. Este no es tu número de IVA ni tu ID de comerciante.",
							"ES": "El NIF/NIE/DNI debe tener 8 o 9 caracteres, comenzando con 1 letra/dígito seguido de 6 o 7 dígitos y 1 letra/dígito",
							"FI": "El número de registro debe tener 8 dígitos y un guion antes del último dígito, sin espacios. Por ej.: 1234567-8",
							"FR": "El número de registro debe tener 9 dígitos, como 123 456 789 o 123456789 (SIREN), o 14 dígitos, como 123 456 789 12345 o 12345678912345 (SIRET).",
							"IE": "El número de inscripción en el registro debe tener 2 letras seguidas de 6 dígitos o solo 6 dígitos si es un empresario individual (por ejemplo, AB123456).",
							"IT": "El número de registro debe tener 11 dígitos (por ej., 01234567890) o una combinación de 16 números y letras mayúsculas (por ej.: ABCABC12A12A123A)",
							"GB": "El número de la organización debe tener 8 dígitos. Por ej.: 12345678 o dos letras seguidas de 6 dígitos (SC123456) o una letra seguida de 7 dígitos (S1234567)",
							"GR": "El número de inscripción en el registro mercantil debería tener 12 dígitos, p. ej., 012345678901",
							"NL": "El número de registro debe tener 8 dígitos. Por ej.: 12345678",
							"NO": "El número de registro debe tener 9 dígitos, sin espacios entre ellos. Por ej.: 123456789",
							"NZ": "El número de empresa debe tener 13 dígitos. Por ej.: 1234567890123",
							"PL": "El número de registro debe tener 10 dígitos, sin espacios. Por ej.: 1234561234",
							"PT": "El número de registro debe tener 9 dígitos, sin espacios entre ellos. Por ej.: 123123123",
							"SE": "El número de registro debe tener 10 dígitos y un guion, sin espacios. Por ej.: 123456-1234",
							"US": "El número debe tener 9 dígitos y un \"-\" después de los dos primeros. Por ej.: 12-3456789",
							"MX": "El RFC debe tener 12 caracteres, empezando por las iniciales de la empresa, los 6 dígitos de la fecha de constitución y el valor de control. Por ej.: ABC921010H20"
						}
					},
					"tocLink": "Se ha producido un error con los términos y condiciones. Inténtalo más tarde o contacta con nuestro servicio de atención al cliente en {supportEmail}",
					"vat": {
						"general": {
							"default": "Indica tu NIF",
							"AU": "Indica un ABN válido",
							"ES": "Introduce un NIF/NIE/DNI válido",
							"NZ": "Indica un número de GST válido"
						},
						"invalid": {
							"default": "Número de IVA no válido",
							"AT": "El número de IVA debe empezar con las letras ATU, seguidas de 8 dígitos. Por ej.: ATU12345678",
							"AU": "El ABN debe tener 11 dígitos.",
							"CZ": "El número de IVA debe empezar con las letras CZ, seguidas de 8, 9 o 10 dígitos. Por ej.: CZ123456789",
							"GR": "El número de IVA debe tener 9 dígitos y comenzar con EL. Por ej.: EL123456789",
							"DE": "El número de IVA debe empezar con las letras DE, seguidas de 9 dígitos. Por ej.: DE123456789",
							"ES": "El NIF/NIE/DNI debe tener 8 o 9 caracteres, comenzando con 1 letra/dígito seguido de 6 o 7 dígitos y 1 letra/dígito",
							"FR": "El número de IVA debe comenzar por FR, seguido de 2 letras/dígitos y 9 dígitos (SIREN), como FRXX123456789",
							"GB": "El número de IVA debe tener entre 6 y 15 caracteres.",
							"IE": "El número de IVA debe empezar por IE, seguido de 8 o 9 caracteres que incluyan 1 o 2 letras. Por ej.: IE1234567WA, IE1234567A",
							"IT": "El número de IVA debe empezar con las letras IT, seguidas de 11 dígitos. Por ej.: IT12345678912",
							"NL": "El número de IVA debe empezar con las letras NL, seguidas de 9 dígitos, una letra B y 2 dígitos más. Por ej.: NL123456789B12",
							"NZ": "El número de GST debe tener 8 dígitos (12345678) o 9 dígitos, con o sin guion entre bloques de 3 dígitos (123-123-123 o 123123123)",
							"PL": "El número de IVA debe empezar con las letras PL, seguidas de 10 dígitos. Por ej.: PL1234567890",
							"PT": "El número de IVA debe empezar con las letras PT, seguidas de 9 dígitos. Por ej.: PT123123123",
							"MX": "El RFC debe empezar por las iniciales de la empresa, los 6 dígitos de la fecha de constitución y el valor de control. Por ej.: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Indica los 4 últimos dígitos de tu Número de la Seguridad Social (SSN)",
							"format": "Introduce los 4 últimos dígitos de tu Número de la Seguridad Social (SSN)"
						},
						"US_FULL_SSN": {
							"general": "Indica el SSN completo (9 dígitos)",
							"format": "Indica tu SSN completo (9 dígitos)"
						},
						"CA": {
							"general": "Indica un SIN o un número de pasaporte válidos",
							"format": "SIN: XXX-XXX-XXX / Número de pasaporte: ABXXXXXX"
						},
						"SE": {
							"general": "Introduce un Número de Identificación Personal (PNO) válido",
							"format": "Introduce el PNO en el formato: AAAAMMDD-XXXX"
						},
						"FI": {
							"general": "Introduce un Código de Identificación Personal (HETU) válido",
							"format": "Introduce el HETU en el formato: DDMMAASXXXX"
						},
						"NO": {
							"general": "Indica un Número de Identidad Nacional válido",
							"format": "Utiliza el formato: DDMMAAXXXXX"
						},
						"DK": {
							"general": "Introduce un Número de Identificación Personal (CPR) válido",
							"format": "Introduce el CPR en el formato: DDMMAA-XXXX"
						},
						"IT": {
							"general": "Indica un código fiscal válido",
							"format": "Indica un código fiscal con el formato: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Indica un número de identidad válido (DNI o NIE)",
							"format": "Indica el DNI o NIE, p. ej.: 12345678A"
						},
						"PL": {
							"general": "Introduce un Código de Identificación Personal (PESEL) válido",
							"format": "Utiliza el formato PESEL: AAMMDDZZZXQ"
						},
						"default": {
							"general": "Indica un número de pasaporte válido"
						}
					},
					"store_name": "Indica un número de tienda"
				},
				"errors_keys": {
					"correlationIdLabel": "Id. de correlación: {correlationId}",
					"decisionTaken": "Ya se tomó la decisión de la evaluación previa. Vuelve a cargar la página.",
					"maintenanceMode": "Nuestra aplicación está inactiva debido a operaciones de mantenimiento. Vuelve a intentarlo más tarde.",
					"validation": {
						"storeName": {
							"invalidType": "Indica un nombre de tienda válido"
						},
						"email": {
							"invalidType": "Indica un e-mail válido."
						},
						"goodsCategory": {
							"invalidType": "Indica la categoría de la mercancía."
						},
						"website": {
							"invalidType": "Indica un sitio web válido."
						}
					}
				}
			},
			"general": {
				"yes": "Sí",
				"no": "No",
				"encrypted_text": "*******",
				"pricing_link_eu": "Ver todos los precios por países",
				"pricing_link_us": "Ver los precios",
				"formFieldOptional": "opcional",
				"buttons": {
					"next": "Siguiente",
					"back": "Atrás",
					"continue": "Continuar",
					"submit_application": {
						"default": "Empezar",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Para empezar"
					},
					"add_aditional_item": "+ Añadir artículo adicional"
				},
				"unknown_step_title": "Introduce la información solicitada",
				"selected": "Seleccionado",
				"clear_all": "Borrar todo"
			},
			"errors": {
				"general": "Se ha producido un error. Contacta con nuestro servicio de atención.",
				"salesforce": "Intenta actualizar la página. Si el error continúa envía el código del error al canal para olvidos #smooothforce-support y te ayudaremos.",
				"managed_kyc": "Intenta actualizar la página. Si el error continúa contacta nuestro servicio de Ayuda al comercio o con tu agente comercial.",
				"copy": "Copiar",
				"noTermsAccepted": "Lee y acepta todos los acuerdos",
				"termsAlreadyAccepted": "Ya has aceptado todos los acuerdos",
				"mandatoryField": " es necesario"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Empresario individual",
					"PARTNERSHIP": "Asociación",
					"PUBLIC_LISTED_COMPANY": "Empresa cotizada en bolsa",
					"PRIVATE_COMPANY": "Empresa privada"
				},
				"organization_entity_types": {
					"C_CORP": "Corporación de tipo C",
					"S_CORP": "Corporación de tipo S",
					"PARTNERSHIP": "Asociación",
					"TRUST_ESTATE": "Fideicomiso/patrimonio",
					"INDIVIDUAL": "Individual",
					"SOLE_PROPRIETORSHIP": "Titularidad unipersonal",
					"SOLE_TRADER": "Empresario individual",
					"LIMITED_LIABILITY_COMPANY": "Sociedad de responsabilidad limitada",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Sociedad de responsabilidad limitada unipersonal"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Ropa y calzado - Ropa y calzado para adultos",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Productos de automoción - Piezas y accesorios para la automoción",
					"BAGS_AND_WALLETS": "Joyería y accesorios - Bolsos y monederos",
					"BODY_AND_HAIR_CARE": "Salud y belleza - Cuidado del cuerpo y el cabello",
					"BOOK_AND_MAGAZINES": "Entretenimiento - Libros y revistas",
					"CANDY": "Alimentos y bebidas - Dulces",
					"CAR_ELECTRONICS": "Electrónica - Electrónica para vehículos",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Productos infantiles - Ropa y productos para la alimentación infantil",
					"CHILDREN_TOYS": "Productos infantiles - Juguetes",
					"CLEANING_AND_SANITARY": "Hogar y jardín - Limpieza e higienización",
					"COLLECTIBLES": "Ocio, deportes y aficiones - Coleccionables",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Ocio, deportes y aficiones - Tiendas de concepto y productos varios",
					"COSMETICS": "Salud y belleza - Cosméticos",
					"COSTUMES_AND_PARTY_SUPPLIES": "Ocio, deporte y aficiones - Disfraces y material para fiestas",
					"DATING_SERVICES": "Productos inmateriales - Servicios de citas",
					"DECORATION_AND_ART": "Hogar y jardín - Decoración y arte",
					"DIETARY_SUPPLEMENTS": "Salud y belleza - Suplementos dietéticos",
					"DIGITAL_SERVICES": "Productos inmateriales - Servicios digitales",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Productos infantiles - Productos infantiles varios",
					"DIVERSIFIED_ELECTRONICS": "Electrónica - Productos electrónicos varios",
					"DIVERSIFIED_ENTERTAINMENT": "Entretenimiento - Entretenimiento variado",
					"DIVERSIFIED_EROTIC_MATERIAL": "Material erótico - Material erótico variado",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Salud y belleza - Productos varios de salud y belleza",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Hogar y jardín - Productos varios de hogar y jardín",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Joyería y accesorios - Joyería y accesorios varios",
					"EDUCATION": "Productos inmateriales - Educación",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Electrónica - Equipos electrónicos y accesorios relacionados",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Material erótico - Prendas y accesorios eróticos",
					"EVENT_TICKETS": "Productos inmateriales - Entradas para eventos",
					"FOOD_AND_BEVERAGE": "Alimentación y bebidas - Alimentos y bebidas",
					"FRAGRANCES": "Salud y belleza - Fragancias",
					"FURNITURE": "Hogar y jardín - Muebles",
					"GENERAL_SHOES_AND_CLOTHING": "Ropa y calzado - Ropa y calzado en general",
					"HOBBY_ARTICLES": "Ocio, deporte y aficiones - Artículos para aficiones",
					"HOUSEHOLD_ELECTRONICS": "Electrónica - Electrónica del hogar",
					"JEWELRY_AND_WATCHES": "Joyería y accesorios - Joyas y relojes",
					"KITCHENWARE": "Hogar y jardín - Menaje de cocina",
					"MARKETPLACES": "Productos inmateriales - Mercados virtuales",
					"MUSIC_AND_MOVIES": "Entretenimiento - Música y cine",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Ocio, deporte y aficiones - Instrumentos y equipos musicales",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Joyería y accesorios - Gafas de sol y lentes no graduadas",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Electrónica - Aparatos de oficina y accesorios relacionados",
					"OTHER_SERVICES": "Productos inmateriales - Otros servicios",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Salud y belleza - Cuidados personales y tratamientos corporales",
					"PET_SUPPLIES": "Hogar y jardín - Productos para mascotas",
					"PHARMACEUTICAL_PRODUCTS": "Salud y belleza - Productos farmacéuticos",
					"PLANTS_AND_FLOWERS": "Hogar y jardín - Plantas y flores",
					"PRESCRIPTION_OPTICS": "Salud y belleza - Óptica de gafas graduadas",
					"PRINTS_AND_PHOTOS": "Ocio, deporte y aficiones - Impresión y fotografía",
					"SAFETY_PRODUCTS": "Hogar y jardín - Productos para la seguridad",
					"SEX_TOYS": "Material erótico - Juguetes sexuales",
					"SPORTS_GEAR_AND_OUTDOOR": "Ocio, deporte y aficiones - Material para deportes y actividades al aire libre",
					"TOBACCO": "Alimentación y bebidas - Tabaco",
					"TOOLS_AND_HOME_IMPROVEMENT": "Hogar y jardín - Herramientas y reformas del hogar",
					"TRAVEL_SERVICES": "Productos inmateriales - Servicios de viajes",
					"UNDERWEAR": "Ropa y calzado - Ropa interior",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entretenimiento - Videojuegos y accesorios relacionados",
					"WHEELS_AND_TIRES": "Productos de automoción - Ruedas y neumáticos",
					"WINE_BEER_AND_LIQUOR": "Alimentos y bebidas - Vino, cerveza y espirituosos",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Ropa y calzado - Ropa y calzado juveniles",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Limitaciones de edad - Juegos de azar, apuestas, casinos y loterías",
					"CHARITIES_AND_NGO": "Productos intangibles - Servicios de organizaciones benéficas y ONG",
					"EROTIC_SERVICES": "Materiales eróticos - Servicios eróticos",
					"FINANCIAL_SERVICES_CRYPTO": "Servicios financieros - Actividades relacionadas con criptomonedas",
					"FINANCIAL_SERVICES_MSB": "Servicios financieros - Empresas de servicios económicos",
					"FINANCIAL_SERVICES_E_WALLETS": "Servicios financieros - Monederos digitales",
					"FINANCIAL_SERVICES_TRADING": "Servicios financieros - Operaciones comerciales",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Productos intangibles - Comunidades de plataformas sociales",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Viajes - Viajes aéreos y operadores de cruceros",
					"TRAVEL_BROKER_AND_AGENCIES": "Viajes - Corredores y agencias",
					"TRAVEL_GROUND_TRANSPORTATION": "Viajes - Transporte terrestre",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Viajes - Alojamiento y complejos turísticos",
					"EVENT_ORGANIZER": "Eventos - Organizador",
					"EVENT_BROKER_AND_AGENCIES": "Eventos - Corredores y agencias"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "California",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "Distrito de Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Hawái",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Luisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Misisipi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "Nuevo México",
					"NY": "Nueva York",
					"NC": "Carolina del Norte",
					"ND": "Dakota del Norte",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregón",
					"PA": "Pensilvania",
					"RI": "Rhode Island",
					"SC": "Carolina del Sur",
					"SD": "Dakota del Sur",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "West Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Persona",
						"COMPANY": "Empresa"
					},
					"roles": {
						"OWNER": "Titular",
						"ULTIMATE_BENEFICIAL_OWNER": "Titular beneficiario en última instancia",
						"CONTROL_OVER_MANAGEMENT": "Control de la gestión",
						"APPLICANT": "Firmante autorizado",
						"SOLE_TRADER": "Empresario individual",
						"PARTNER": "Socio"
					}
				},
				"payment_intervals": {
					"DAILY": "Diariamente",
					"WEEKLY": "Semanalmente"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Venta tradicional de bienes",
						"description": "El comerciante se dedica a la venta de productos o servicios de forma tradicional: los bienes se consideran totalmente consumidos en el momento de ser entregados y, por lo general, el plazo entre el pedido y la entrega no es muy largo"
					},
					"VOUCHER": {
						"label": "Vale",
						"description": "Más del 10 % de las ventas son de vales y/o tarjetas regalo"
					},
					"MEMBERSHIP": {
						"label": "Afiliación",
						"description": "Más del 10 % de las ventas son de afiliación"
					},
					"SUBSCRIPTION": {
						"label": "Suscripción",
						"description": "Más del 10 % de las ventas son de suscripción"
					},
					"PHARMACIES": {
						"label": "Farmacias",
						"description": "El comerciante vende medicamentos con o sin receta médica"
					},
					"US_PHARMACIES": {
						"label": "Farmacias de EE. UU.",
						"description": "El comercio vende medicamentos con o sin receta en EE. UU."
					},
					"MEDICAL_SERVICES": {
						"label": "Servicios médicos",
						"description": "El comercio vende servicios médicos como análisis, exploraciones y atención de enfermería"
					},
					"MARKETPLACES": {
						"label": "Mercados virtuales",
						"description": "El comerciante tiene una relación de sucursal"
					},
					"FIREARM_DEALERS": {
						"label": "Venta de armas",
						"description": "El comerciante vende armas y munición que requieren licencia"
					},
					"AUCTIONS": {
						"label": "Subastas",
						"description": "El comerciante es una casa de subastas"
					},
					"ALCOHOL": {
						"label": "Alcohol",
						"description": "El comerciante vende bebidas alcohólicas"
					},
					"TOBACCO": {
						"label": "Tabaco",
						"description": "El comerciante vende tabaco, con o sin nicotina, o el comerciante vende cigarrillos electrónicos"
					},
					"HEMP_CBD_THC": {
						"label": "Cáñamo, CBD o THC",
						"description": "El comerciante vende productos que contienen cáñamo, CBD o THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Donaciones y beneficencia",
						"description": "El comerciante es una organización benéfica o de donaciones que practica el desembolso tras la liquidación “Post Settlement Disbursement\""
					},
					"TRAVEL": {
						"label": "Viajes",
						"description": "Más del 10 % de las ventas son viajes"
					},
					"EVENTS": {
						"label": "Eventos",
						"description": "Más del 10 % de las ventas son eventos"
					},
					"COURSES": {
						"label": "Cursos",
						"description": "Más del 10 % de las ventas son cursos"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Cursos educativos",
						"description": "El comercio vende cursos educativos que duran un periodo de tiempo determinado."
					},
					"FOOD_DELIVERY": {
						"label": "Entrega de comida",
						"description": "El comercio ofrece un servicio de entrega de comida."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Artículos personalizados bajo pedido/Muebles",
						"description": "El comercio vende productos bajo pedido, como muebles."
					},
					"DIGITAL_CONTENT": {
						"label": "Contenido digital",
						"description": "El comercio vende contenido digital, como libros electrónicos y juegos online."
					},
					"GAMING_INDUSTRY": {
						"label": "Industria del juego (juegos, apuestas, casinos, loterías)",
						"description": "El comercio ofrece servicios relacionados con la industria del juego, como juegos, apuestas, casinos y loterías."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hola, {firstName}",
						"primary_title_without_name": "Hola,",
						"sub_title": "Más Klarna significa más Klarna, como dijo Shakespeare.",
						"sub_title_no_products": "Para iniciar tu experiencia con Klarna elige uno de los productos siguientes",
						"sub_title_kp_products": "Selecciona otro producto Klarna",
						"sub_title_ongoing_product": "Sigue con la configuración de {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Productos de pago",
							"text_blocks": [
								{
									"text": "Añade una solución a tu configuración"
								}
							]
						}
					},
					"buttons": {
						"start": "Empezar",
						"continue": "Continuar",
						"view_summary": "Ver resumen",
						"add_another_product": "Añade otro producto"
					},
					"goodie_bags": {
						"playground": {
							"title": "Sitio de prueba",
							"text": "Cambia al entorno del sitio de prueba para investigar y generar credenciales API de prueba, y ver cómo funciona tu plataforma.",
							"link": "Sitio de prueba"
						},
						"marketing_assets": {
							"title": "Material de marketing",
							"text": "Utilizar Klarna es navegar smoooth hacia nuevos horizontes de clientes. Aprovecha nuestro material de marketing para seducirles.",
							"link": "Obtener el material"
						},
						"your_application": {
							"title": "Tu solicitud",
							"text": "Clica aquí para finalizar tu configuración o ver los datos de tu aplicación, incluidas las Condiciones generales.",
							"link": "Abrir"
						},
						"invite_more_users": {
							"title": "Invita a nuevos usuarios",
							"text": "Invita a tus colaboradores al Portal del comercio. Podrás personalizar los permisos para cada uno.",
							"link": "Invitar a usuarios"
						}
					},
					"footer": {
						"title": "Siempre incluidos con Klarna",
						"list": {
							"merchant_portal": {
								"title": "El Portal del comercio",
								"text_blocks": [
									{
										"text": "Gestiona todo en Klarna con pleno acceso al backend."
									}
								]
							},
							"global_products": {
								"title": "Productos globales, rostros locales",
								"text_blocks": [
									{
										"text": "Todos nuestros productos respetan las preferencias y la legislación locales."
									}
								]
							},
							"local_support": {
								"title": "Ayuda de proximidad para ti y para tus clientes",
								"text_blocks": [
									{
										"text": "Disponemos de miles de personas dispuestas a ayudar a tus clientes siempre que necesiten un toque humano."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna como herramienta de marketing",
								"text_blocks": [
									{
										"text": "Te daremos acceso a material de Klarna que puedes utilizar en tus acciones de marketing."
									}
								]
							},
							"single_integration": {
								"title": "Integración única, actualizaciones automáticas",
								"text_blocks": [
									{
										"text": "Una integración, sin actualizaciones. Nunca."
									},
									{
										"text": "Una vez que integres Klarna, ¡ya está! Siempre estará actualizada, sin que tengas que mover ni un dedo."
									}
								]
							},
							"no_risk": {
								"title": "Sin riesgos para ti ni para tus clientes.",
								"text_blocks": [
									{
										"text": "Tus pagos siempre están garantizados y tus clientes están seguros con la protección del comprador de Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Credenciales de API de Klarna",
							"text_blocks": [
								{
									"text": "Las credenciales de la API de Klarna conectan nuestro producto con tu tienda para que puedas empezar a vender."
								}
							]
						},
						"toc_key": {
							"title": "las Condiciones generales",
							"text_blocks": [
								{
									"text": "Necesitas actualizar tus Condiciones generales de e-commerce"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Instrucciones para la integración",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Utilización de las credenciales de la API de Klarna",
							"ordered_list": {
								"one": "Genera y descarga tus credenciales",
								"two": "Pega las credenciales (nombre de usuario y contraseña de la API de Klarna) en tu plataforma, según se explica a continuación en las instrucciones para la integración"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "En total, 5 credenciales para la API de Klarna",
							"text": "Puedes generar hasta un máximo de 5 credenciales para la API de Klarna. Obtén la primera aquí y crea después las demás en la Configuración.",
							"button": "Generar credenciales de la API de Klarna"
						},
						"how_to_update_toc": {
							"title": "Actualización de las Condiciones generales",
							"ordered_list": {
								"one": "Sigue el enlace",
								"two": "Lee las instrucciones y copia el texto",
								"three": "Incluirlo en las Condiciones generales de tu tienda en línea"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Recuerda que debes actualizar el texto con los productos en los que te has registrado.",
							"linkText": "Ve a Actualizar las Condiciones generales >"
						},
						"buttons": {
							"back": "Atrás"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Se está revisando tu solicitud…",
						"TRANSACTION_DETAILS_STARTED": "Nuestro equipo está revisando tu solicitud. Te responderemos lo antes posible.",
						"TRANSACTIONS_REVIEW_MANUAL": "Nuestro equipo está revisando tu solicitud. Te responderemos lo antes posible.",
						"TRANSACTIONS_ENABLED": "¡Enhorabuena! Ya lo tienes todo para empezar a vender con Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "Tu solicitud de pagos se está revisando…",
						"PAYOUTS_REVIEW_MANUAL": "Nuestro equipo está revisando tu solicitud de pagos. Te responderemos lo antes posible.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Esperando tu primera venta con Klarna...",
						"TRANSACTIONS_DISABLED": "Tu cuenta estará desactivada hasta que completes el paso de habilitar los pagos.",
						"SUSPENDED": "Tu cuenta está suspendida.",
						"notice": "El tiempo de espera actual para revisar tu solicitud es superior al habitual. No te preocupes, tu solicitud se está revisando y pronto te informaremos de los siguientes pasos. Agradecemos tu paciencia y tu comprensión."
					},
					"statuses": {
						"pending": "Pendiente",
						"done": "Hecho"
					},
					"in_review": {
						"title": "Se está revisando tu solicitud.",
						"subtitle": "Estamos terminando de revisar tu solicitud a Klarna para asegurarnos de que los términos del contrato sean correctos. Como este proceso es manual, su duración puede variar, pero lo haremos lo más rápido posible.",
						"content": {
							"title": "Para agilizar la revisión al máximo, comprueba que esté visible en el sitio web lo que se indica a continuación:",
							"list": {
								"default": {
									"item_1": "El nombre oficial de tu empresa",
									"item_2": "El número de registro de tu empresa",
									"item_3": "La dirección oficial de tu empresa",
									"item_4": "Política de devoluciones de al menos 14 días",
									"item_5": "Dirección electrónica o número de atención al cliente"
								},
								"US": {
									"item_1": "Nombre oficial de la empresa",
									"item_2": "Política de devoluciones",
									"irem_3": "Dirección electrónica o número de atención al cliente"
								},
								"AU": {
									"item_1": "ABN (número de empresa) o nombre oficial de la empresa.",
									"item_3": "La dirección oficial de tu empresa",
									"item_4": "Política de devolución de al menos 14 días",
									"item_5": "Dirección electrónica o número de atención al cliente"
								}
							}
						},
						"footer": "Te enviaremos un e-mail al finalizar la revisión o si necesitamos que nos facilites información adicional."
					},
					"suspended": {
						"title": "Lamentablemente…",
						"subtitle": "Después de revisar los datos del contrato, debemos denegar tu solicitud. Tu solicitud puede no haber sido aprobada por varias razones. A continuación encontrarás algunos de los motivos más habituales:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Tu tienda no cumple con el código ético de Klarna.",
								"item_2": "La persona de contacto indicada no se encuentra localizable.",
								"item_3": "Otros motivos técnicos o administrativos."
							}
						},
						"footer": "Gracias por tu interés en Klarna. Contacta con nosotros si tienes preguntas o si deseas registrarte con una tienda distinta en un futuro."
					},
					"disabled": {
						"title": "Tu solicitud ha sido deshabilitada.",
						"subtitle": "Tu cuenta se ha desactivado automáticamente porque falta información legal obligatoria.",
						"content": {
							"title": "Esto suele ocurrir cuando Klarna te solicita determinada información y no la aportas dentro del plazo especificado."
						},
						"footer": "Si crees que se trata de un error o deseas volver a enviar la información, contacta con el servicio de Ayuda al comercio según los datos de contacto que figuran al pie de esta página."
					},
					"ready_to_connect": {
						"title": "Conecta tu tienda",
						"subtitle": "Tu contrato está completo. Ya puedes integrar Klarna en tu tienda. Sigue los pasos siguientes para llevar a cabo la integración.",
						"status_messsage": {
							"title": "La integración no ha finalizado todavía",
							"subtitle": "Sigue las instrucciones para la integración para conectar tu tienda. Este indicador de estado cambiará a verde cuando se lleve a cabo una transacción utilizando Klarna."
						},
						"content": {
							"title": "Instrucciones",
							"options": {
								"label_1": "Genera y guarda tus credenciales de la API de Klarna",
								"description_1": "Genera nuevas credenciales de la API y descárgalas en tu ordenador. Vas a necesitar estas credenciales de la API en la sección siguiente.",
								"label_2": "Instala Klarna en tu tienda Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Ya casi hemos acabado",
						"subtitle": "Estás un paso más cerca de ofrecer una experiencia de compra smoooth a tus clientes. Se ha preparado tu contrato y tu tienda está lista para la integración.",
						"buttons": {
							"connect": "Conecta tu tienda"
						},
						"additional_info": "Ten en cuenta que la integración solo aparecerá como completada cuando recibamos la primera compra, lo que puede tardar bastante, dependiendo de tu plataforma."
					},
					"store_connected": {
						"title": "Tu tienda está conectada",
						"subtitle": "La integración de tu tienda a Klarna ha finalizado y tus clientes ya podrán pagar usando Klarna.",
						"status_messsage": {
							"title": "Integración correcta",
							"subtitle": "Se ha procesado correctamente una transacción con Klarna a través de tu tienda.",
							"button_text": {
								"shown": "Mostrar las instrucciones para la integración",
								"hidden": "Ocultar las instrucciones para la integración"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Tu solicitud",
							"subtitle": "Revisa la información de tu solicitud.",
							"button_text": "Ver resumen"
						},
						"connect_store": {
							"title": "Credenciales de la API de Klarna",
							"subtitle": "Genera tus credenciales de la API de Klarna para integrar tu tienda.",
							"button_text": "Generar credenciales de la API de Klarna"
						},
						"add_product": {
							"title": "Productos",
							"subtitle": "Haz clic aquí si deseas añadir un producto para esta configuración.",
							"button_text": "Añadir productos"
						}
					},
					"timeline": {
						"application": {
							"title": "Tu solicitud",
							"alert": {
								"view_summary": "Ver resumen",
								"rejected": "Hemos tenido que rechazar tu aplicación.",
								"review": "Revisa los datos de tu aplicación haciendo clic en el enlace que aparece a continuación."
							}
						},
						"payouts": {
							"title": "Pagos habilitados"
						},
						"integration": {
							"title": "La integración no ha finalizado todavía",
							"alert": "Sigue las instrucciones para la integración para conectar tu tienda."
						},
						"integration_complete": {
							"title": "¡La integración se ha completado!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "¡Enhorabuena! Tu configuración ha finalizado.",
						"rejection": "Lo sentimos, no se ha podido completar tu configuración."
					},
					"header_new": {
						"title": "Te damos la bienvenida, comerciante de Klarna",
						"subtitle": "Summary",
						"rejection": "Solicitud denegada"
					},
					"joy_section": {
						"approved": {
							"title": "¡Se ha aprobado!",
							"content": "Tu solicitud ha sido revisada y aprobada. Ya puedes acceder fácilmente a todos los servicios de Klarna. ¡Será fantástico trabajar contigo!",
							"button_title": "Consulta tus pedidos",
							"link": "o nuestro material de marketing"
						},
						"rejected": {
							"title": "Lamentablemente…",
							"content_1": "Después de revisar tu solicitud, no podemos aprobar tu contrato de comerciante.",
							"content_2": "Puedes contactar con nuestro equipo de atención para cualquier pregunta."
						}
					},
					"sidebar_left": {
						"application_details": "Los datos de tu solicitud",
						"store_details": {
							"title": "Datos de la tienda",
							"text_blocks": [
								{
									"text": "Un resumen de tus datos"
								}
							]
						},
						"credentials": {
							"title": "Credenciales de la API de Klarna",
							"text_blocks": [
								{
									"text": "Tus credenciales de la API de Klarna"
								}
							]
						},
						"payouts": {
							"title": "Pagos",
							"text_blocks": [
								{
									"text": "Los datos bancarios que proporcionaste"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Cuentas bancarias adicionales",
							"text_block": null
						},
						"business_owners": {
							"title": "Titulares de la empresa",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Influencers importantes",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Accionistas",
							"text_blocks": [
								{
									"text": "La información que proporcionaste"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Titulares de la empresa",
								"no_elements": "No indicaste ningún titular de la empresa"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Cuenta bancaria predeterminada",
								"no_elements": "No se dispone de cuenta bancaria predeterminada"
							},
							"additional_bank_accounts": {
								"title": "Cuentas bancarias adicionales",
								"no_elements": "No indicaste ninguna cuenta bancaria adicional"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Titulares",
								"no_elements": "No indicaste ningún titular"
							},
							"ultimate_beneficial_owner": {
								"title": "Titulares beneficiarios",
								"no_elements": "No indicaste ningún titular beneficiario"
							},
							"applicant": {
								"title": "Solicitantes",
								"no_elements": "No indicaste ningún solicitante adicional"
							},
							"control_over_management": {
								"title": "Personas con poder de control sobre la dirección",
								"no_elements": "No indicaste ningún accionista con poder de control sobre la dirección"
							}
						},
						"buttons": {
							"back": "Atrás",
							"next_step": "Siguiente"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Ya disponemos de tus datos",
							"text_blocks": [
								{
									"text": "Esta es la información que nos facilitaste previamente."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "No indicaste ningún titular de la empresa"
						},
						"buttons": {
							"submit": "Enviar",
							"back": "Atrás"
						}
					}
				},
				"checking_page": {
					"title": "Se está comprobando…",
					"subtitle": "Gracias por enviar la solicitud. Espera mientras la comprobamos…"
				},
				"success_page": {
					"title": "Ya puedes conectar tu tienda",
					"subtitle": "Gracias por enviar la solicitud.",
					"buttons": {
						"next": "Siguiente"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Lo básico",
						"business": "Empresa",
						"stakeholders": "Partes interesadas",
						"bank_accounts": "Cuentas bancarias"
					}
				},
				"app_error": {
					"title": "La app de Productos no está disponible en este momento",
					"message": "Tenemos algunos problemas con nuestra aplicación y ya los estamos investigando. Intentaremos solucionarlos lo antes posible. Vuelve a intentarlo más tarde."
				},
				"temporarily_down": {
					"title": "Tenemos algunos problemas técnicos.",
					"message": "¡Disculpa las molestias! Te garantizamos que estamos haciendo todo lo posible por resolver los problemas. Vuelve a intentarlo más tarde."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Nuestra app Productos está inactiva debido a operaciones de mantenimiento",
						"signup_app": "Nuestra app para Registrarse está inactiva debido a tareas de mantenimiento"
					},
					"message": "Estamos trabajando para mejorar tu experiencia y esperamos terminar lo antes posible. Vuelve a intentarlo más tarde."
				},
				"unknown_merchant": {
					"before_link": "Si ya tienes un acuerdo con nosotros, visita",
					"link_text": "esta página",
					"after_link": "para conocer mejor nuestros productos"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Se ha producido un error.",
						"invalid_token": "Este enlace ha caducado"
					},
					"message": {
						"invalid_token_risk": " Contacta el canal para olvidos #smooothforce-support y te ayudaremos.",
						"invalid_token": "Contacta con tu agente comercial.",
						"invalid_flow_type": "El tipo y el estado de admisión de este comerciante son incompatibles. Si crees que se trata de un error, contacta con el servicio de Ayuda al comercio."
					}
				},
				"topbar": {
					"title": "Configuración",
					"widget_type": {
						"MANAGED_KYC": "Colección de conocimiento del cliente (KYC)",
						"MANAGED_RISK": "Colección previa a la evaluación",
						"MANAGED_SME_RISK": "Colección previa a la evaluación de SME"
					}
				},
				"product_card": {
					"incompatible_description": "No está disponible para tu país/plataforma",
					"kco_footer_text": "Los métodos de pago disponibles en Klarna Checkout dependen del país donde estés registrado y del país donde vendas.",
					"products_link_text": "Más"
				},
				"product_prices_card": {
					"title": "Productos",
					"subtitle": "{country}",
					"pricing": "Precios para {country}",
					"monthly_fee": "comisión mensual",
					"transaction_fee": "comisión por transacción",
					"before_link": "Acepto las",
					"link_text": "las Condiciones generales",
					"after_link_one_product": "de este producto",
					"after_link_more_than_one_product": "de estos productos",
					"product_not_available_in_your_country": "* Este producto no está disponible en tu mercado nacional, pero funcionará en otros países.",
					"edit_link": "Editar",
					"merchant_agreement": {
						"before_link": "Acepto",
						"link_text": "Acuerdo del comercio",
						"after_link_one_product": "para este producto",
						"after_link_more_than_one_product": "para estos productos"
					},
					"pricing_annex": {
						"before_link": "Acepto",
						"link_text": "las Condiciones de precios",
						"after_link_one_product": "para este producto"
					}
				},
				"support_footer": {
					"text": "Atención en inglés",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Todos los derechos reservados.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Condiciones generales.",
					"privacy_policy": "Política de privacidad",
					"merchant_id": "ID del comerciante {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Ayuda al comercio",
					"recaptcha": {
						"1_main_text": "Este sitio está protegido por reCAPTCHA y la",
						"2_privacy_policy": "Política de privacidad de Google",
						"3_and": "y",
						"4_terms_of_service": "Las Condiciones de uso",
						"5_apply": "son aplicables."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Precios para todos nuestros mercados",
					"title_us": "Precios",
					"subtitle": "Solo se te cobra una comisión por transacción, ¡esto sí es smoooth!",
					"table": {
						"country": "País",
						"price_column_heading": "Comisión por transacción",
						"global": "Global",
						"title": {
							"kp": "Formas de pago",
							"kco": "Pago con Klarna",
							"kco_one": "Pago con Klarna",
							"kp_one": "Método de pago Klarna"
						},
						"headers": {
							"kp_one": "Cargo por servicio"
						}
					},
					"buttons": {
						"back": "Atrás"
					},
					"foot_notes": {
						"global_price": "* Moneda local del comerciante, en otros casos "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Primera transacción",
						"content": "Para poder revisar tus datos de pago necesitamos un primer pedido. ¿No quieres malgastar tu dinero? ¡Ningún problema!",
						"button": "¡Falsifícalo!"
					},
					"transactions": {
						"title": "Aprobar transacciones",
						"content": "Puedes, simplemente, falsificar la aprobación de la transacción por parte del vendedor",
						"button": "Aprobar"
					},
					"payouts": {
						"title": "Aprobar los pagos",
						"content": "Puedes, simplemente, falsificar la aprobación de los pagos por parte del vendedor",
						"button": "Aprobar"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Cuenta bancaria predeterminada",
						"additional": "Cuenta bancaria adicional {index}",
						"normal": "Cuenta bancaria {index}"
					},
					"currency_code": {
						"label": "Moneda"
					},
					"country_of_bank_account": {
						"label": "País"
					},
					"account_number": {
						"label": {
							"default": "Número de cuenta",
							"MX_LOCAL": "Número CLABE"
						}
					},
					"account_holder": {
						"label": "Nombre del titular de la cuenta"
					},
					"routing_number": {
						"label": "Número de encaminamiento"
					},
					"transit_number": {
						"label": "Número de tránsito"
					},
					"institution_number": {
						"label": "Número de entidad"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Una vez finalizada tu incorporación podrás editar la información de la cuenta bancaria"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Denominación legal de la empresa"
					},
					"country": {
						"label": "País"
					},
					"registrationId": {
						"label": {
							"default": "Número de inscripción en el registro",
							"AT": "Número de inscripción en el registro",
							"AU": "ACN",
							"CA": "Número de empresa",
							"ES": "NIF/NIE/DNI de la empresa",
							"GB": "Número de organización",
							"GR": "Número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)",
							"US": "Número de Identificación de Empresa"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Tribunal de registro"
					},
					"goodsCategory": {
						"label": "Categoría de mercancías"
					},
					"registered": {
						"label": {
							"default": "Empresa registrada",
							"AU": "La empresa tiene un ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "La empresa está sujeta a IVA",
							"AU": "La empresa está sujeta a ABN",
							"ES": "La empresa tiene un NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Número de IVA",
							"AU": "ABN",
							"ES": "NIF/NIE/DNI de la empresa"
						}
					},
					"storeName": {
						"label": "Nombre de la tienda"
					},
					"website": {
						"label": "Sitio web"
					},
					"email": {
						"label": "Correo electrónico de ayuda para el cliente"
					},
					"entityType": {
						"label": "Tipo de entidad"
					},
					"toc_data": {
						"label": "Condiciones generales",
						"toc_approval_text": {
							"before_link": "Tus",
							"link_text": "condiciones generales",
							"after_link": "aceptadas el {date}",
							"merchant_agreement": {
								"before_link": "Tu",
								"link_text": "Acuerdo del comercio",
								"after_link": "aceptado el {date}"
							},
							"pricing_annex": {
								"before_link": "Tu",
								"link_text": "Anexo de precios",
								"after_link": "aceptado el {date}"
							}
						}
					},
					"companyName": {
						"label": "Nombre de asociación"
					},
					"registeredCompanyName": {
						"label": "Nombre de la empresa"
					},
					"address": {
						"label": "Dirección"
					},
					"operatingAddress": {
						"label": "Domicilio profesional"
					},
					"organizationEntityType": {
						"label": "Clasificación fiscal"
					}
				},
				"api_key_dialog": {
					"title": "Credenciales de la API de Klarna generadas",
					"subtitle": "Las credenciales solo se mostrarán una vez. Haz clic en el botón siguiente para descargar tus credenciales antes de cerrar esta ventana.",
					"key_box": {
						"username": {
							"label": "Nombre de usuario de la API de Klarna"
						},
						"password": {
							"label": "Contraseña de la API de Klarna"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Descargar en formato .txt"
					}
				},
				"platform_instructions": {
					"step": "Paso {current}/{max}",
					"next": "Siguiente",
					"back": "Atrás",
					"shopify": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							],
							"alternate": [
								{
									"text": "Para más información sobre la integración de Shopify, sigue la"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guía de integración ampliada."
								}
							]
						},
						{
							"title": "Instala Klarna en tu tienda Shopify",
							"step_instructions": [
								[
									{
										"text": "Dirígete al"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Asistente de configuración del método de pago Klarna en Shopify."
									}
								],
								[
									{
										"text": "Sigue las instrucciones que se ofrecen allí para finalizar tu integración."
									}
								]
							],
							"alternate": [
								{
									"text": "Para más información sobre la integración de Shopify, sigue la"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guía de integración ampliada."
								}
							]
						},
						{
							"title": "Haz una compra de prueba",
							"step_instructions": [
								[
									{
										"text": "Para verificar que la integración esté configurada correctamente, haz una compra de prueba en tu tienda."
									}
								],
								[
									{
										"text": "Después de emitir el pedido ve a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Pedidos en el Portal del comercio,"
									},
									{
										"text": "busca tu pedido y cancélalo para no tener que pagarlo."
									}
								],
								[
									{
										"text": "Una vez finalizada tu integración correctamente, el banner de la parte superior de esta página cambiará a verde y mostrará el texto \"Integration Completed\"."
									}
								]
							],
							"alternate": [
								{
									"text": "Para más información sobre la integración de Shopify, sigue la"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guía de integración ampliada."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Habilita el complemento del método de pago Klarna para Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Para poder instalar el complemento de Klarna necesitarás un sistema en funcionamiento de Plentymarkets CERES. El"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "complemento Ceres"
									},
									{
										"text": "está disponible para descarga en plentyMarketplace. Desde allí también se te reenviará a"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "las instrucciones de instalación."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Klarna en Plentymarkets Ceres sigue"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "este enlace."
									}
								]
							]
						},
						{
							"title": "Instalación y configuración",
							"step_instructions": [
								[
									{
										"text": "La instalación del complemento de Klarna se lleva a cabo a través de"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "También se te reenviará a plentyMarketplace desde el backend del sistema de Plentymarkets. Para"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instrucciones sobre la instalación de complementos en Plentymarkets"
									},
									{
										"text": "busca en plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Klarna en Plentymarkets Ceres sigue"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "este enlace."
									}
								]
							]
						},
						{
							"title": "Configuración del complemento",
							"step_instructions": [
								[
									{
										"text": "El complemento se configura directamente en el juego correspondiente. Al hacer clic en la línea del"
									},
									{
										"bold": "complemento de Klarna"
									},
									{
										"text": "se abre la página de la configuración."
									}
								],
								[
									{
										"text": "La configuración se divide en dos áreas:"
									},
									{
										"list": [
											[
												{
													"bold": "Autenticación:"
												},
												{
													"text": "Se utiliza el modo para determinar si es de prueba o de producción. Dependiendo del modo, deben almacenarse el nombre de usuario y la contraseña."
												}
											],
											[
												{
													"bold": "Configuración general:"
												},
												{
													"text": "Aquí se selecciona el producto que se desea utilizar. pueden ser métodos de pago individuales de Klarna (Klarna Payments) o todo el sistema de pago de Klarna (Klarna Checkout). Al seleccionar todo el sistema de pago, el sistema propio de la tienda se anula y se sustituye automáticamente por Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "No se necesita seguir configurando y, en caso de desactivar el complemento, esto se revertirá."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Klarna en Plentymarkets Ceres sigue"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "este enlace."
									}
								]
							]
						},
						{
							"title": "Información final",
							"step_instructions": [
								[
									{
										"text": "Requisitos del sistema:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets, versión 7"
											},
											{
												"text": "Complementos Ceres e IO instalados"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Klarna en Plentymarkets Ceres sigue"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "este enlace."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Habilita el complemento Klarna Checkout para WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Primero, comprueba que esté instalado el complemento Klarna Checkout para WooCommerce. Si no tienes el complemento, dirígete a"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								],
								[
									{
										"text": "Cuando tengas tus credenciales de la API de Klarna, ve a “Settings” (Configuración) y después a “Checkout” (Pago) del panel de WooCommerce. Elige Klarna Checkout."
									}
								],
								[
									{
										"text": "Marca la casilla Habilitar Klarna Checkout para habilitarlo."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta su"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guía ampliada."
									}
								]
							]
						},
						{
							"title": "Configura tus parámetros",
							"step_instructions": [
								[
									{
										"text": "Configura tus parámetros para Klarna Checkout. Ten en cuenta que el campo “Title” (Título) se utiliza para establecer el nombre del método de pago mostrado en tu página de pago y en los e-mails de confirmación del pedido (por ejemplo, Klarna Checkout)."
									}
								],
								[
									{
										"text": "Marca la casilla “Test mode” (Modo de prueba) si deseas crear pedidos con estas credenciales."
									}
								],
								[
									{
										"text": "Después debes especificar la configuración del país. Si tienes tu sede en Europa, haz clic en “expand” (ampliar) para la sección de Europa. Si tienes tu sede en EE. UU., haz clic en “expand” (ampliar) para la sección de Estados Unidos."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta su"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guía ampliada."
									}
								]
							]
						},
						{
							"title": "Añade tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Añade tus credenciales de la API de Klarna en los campos nombre de usuario y contraseña de la API de Klarna."
									}
								],
								[
									{
										"text": "Guarda tu configuración."
									}
								],
								[
									{
										"text": "Finalmente, establece Klarna Checkout como tu método de pago predeterminado. Ve a “Settings” (Configuración) y a “Payments” (Pagos) en el panel de WooCommerce. Busca la sección “Payment methods” (Métodos de pago) y establece Klarna Checkout como método de pago predeterminado."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta su"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guía ampliada."
									}
								]
							]
						},
						{
							"title": "Últimos pasos",
							"step_instructions": [
								[
									{
										"text": "Recuerda que debes habilitar"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "Pretty Permalinks"
									},
									{
										"text": "en tu instalación WordPress. De lo contrario, las devoluciones de llamadas de Klarna a tu tienda no funcionarán y el estado o la información de los pedidos no se actualizará correctamente."
									}
								],
								[
									{
										"text": "Si deseas manejar tu pedido de Klarna directamente en WooCommerce necesitas instalar"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarna Order Management"
									},
									{
										"text": "como complemento."
									}
								],
								[
									{
										"text": "Comprueba que Klarna Checkout se muestre de la forma prevista. Para ello, añade un artículo a tu carrito y sigue el proceso de pago (no emitas el pedido realmente)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta su"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guía ampliada."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Instala y habilita el complemento del método de pago Klarna",
							"step_instructions": [
								[
									{
										"text": "Instala"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Complemento del método de pago Klarna para WooCommerce."
									}
								],
								[
									{
										"text": "En tu cuenta WooCommerce, ve a"
									},
									{
										"bold": "Settings (Configuración) → Payments (Pagos) → Klarna Payment Method (Método de pago Klarna)."
									}
								],
								[
									{
										"text": "Marca la casilla del método de pago Klarna para habilitarlo."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Establece tu configuración de país",
							"step_instructions": [
								[
									{
										"text": "Rellena los datos de configuración del país. Cada país incluido en Klarna tiene sus propios parámetros de configuración. Al añadir las credenciales del comercio en un país específico también habilitas el método de pago Klarna para que esté disponible en ese país."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Introduce tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Introduce tus credenciales de la API de Klarna en los campos nombre de usuario y contraseña de la API de Klarna."
									}
								],
								[
									{
										"text": "Guarda tu configuración."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Haz una compra de prueba",
							"step_instructions": [
								[
									{
										"text": "Para verificar que la integración esté configurada correctamente, haz una compra de prueba en tu tienda."
									}
								],
								[
									{
										"text": "Después de emitir el pedido ve a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Pedidos en el Portal del comercio,"
									},
									{
										"text": "busca tu pedido y cancélalo para no tener que pagarlo."
									}
								],
								[
									{
										"text": "Una vez finalizada tu integración correctamente, el banner de la parte superior de esta página cambiará a verde y mostrará el texto \"Integration Completed\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de WooCommerce, consulta la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guía de integración ampliada."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Configura tus parámetros para habilitar Klarna Checkout.",
							"step_instructions": [
								[
									{
										"text": "Primero, comprueba que esté instalado el módulo Klarna Checkout para Magento. Si todavía no tienes el módulo, dirígete a"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								],
								[
									{
										"text": "Cuando tengas tus credenciales de la API de Klarna, abre tu panel de Magento. Ve a “Stores” (Tiendas) → “Configuration” → “Sales” (Ventas) → “Payment methods” (Métodos de pago) → ”Klarna” → “Klarna API”."
									}
								],
								[
									{
										"text": "Amplía la sección “Klarna API” y rellena los datos de tu versión de API, nombre de usuario y contraseña de la API de Klarna. Recuerda desactivar el modo de prueba si lo tienes todo listo para funcionar públicamente en tu sitio."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Magento, consulta su"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "guía ampliada."
									}
								]
							]
						},
						{
							"title": "Últimos pasos",
							"step_instructions": [
								[
									{
										"text": "Una vez configurados tus parámetros, deberás comprobar que Klarna Checkout esté habilitado en tus opciones de pago."
									}
								],
								[
									{
										"text": "En tu panel de Magento ve a “Stores” (Tiendas) → “Configuration” → “Sales” (Ventas) → “Checkout” (Pagar) → “Klarna Checkout Options”."
									}
								],
								[
									{
										"text": "Klarna Checkout debería estar habilitado por defecto. Si no lo está, activa"
									},
									{
										"bold": "Habilitar"
									},
									{
										"text": "en “Enable Klarna Checkout” (Habilitar Klarna Checkout)."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							]
						},
						{
							"title": "Instala y activa el módulo del método de pago Klarna",
							"step_instructions": [
								[
									{
										"text": "Consulta la sección"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Configuración de Klarna en el Manual de usuario de Magento"
									},
									{
										"text": "y sigue las instrucciones que se indican para instalar y configurar el módulo en tu cuenta Magento."
									}
								]
							]
						},
						{
							"title": "Haz una compra de prueba",
							"step_instructions": [
								[
									{
										"text": "Para verificar que la integración esté configurada correctamente, haz una compra de prueba en tu tienda."
									}
								],
								[
									{
										"text": "Después de emitir el pedido ve a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Pedidos en el Portal del comercio,"
									},
									{
										"text": "busca tu pedido y cancélalo para no tener que pagarlo."
									}
								],
								[
									{
										"text": "Una vez finalizada tu integración correctamente, el banner de la parte superior de esta página cambiará a verde y mostrará el texto \"Integration Completed\"."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Habilita el complemento del método de pago Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Primero, comprueba que esté instalado el complemento del método de pago Klarna para Shopware. Si no tienes el complemento, dirígete a"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								],
								[
									{
										"text": "En el paso siguiente necesitarás importar el complemento del método de pago  Klarna a Shopware. Para ello, haz clic en"
									},
									{
										"bold": "Configuration → Plugin Manager (Administrador de complementos) → Installled (Instalados) → Upload Plugin (Cargar complemento)."
									},
									{
										"text": "Haz clic"
									},
									{
										"bold": "Seleccionar"
									},
									{
										"text": "y selecciona el archivo ZIP de complementos del método de pago Klarna. Para confirmar, haz clic en"
									},
									{
										"bold": "Cargar complemento."
									},
									{
										"text": "Ahora el complemento se puede encontrar en el administrador de complementos."
									}
								],
								[
									{
										"text": "Para instalar el complemento haz clic en"
									},
									{
										"bold": "el icono “+”"
									},
									{
										"text": "de color verde."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Configura el complemento del método de pago Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Ve a la configuración de los complementos. Para ello haz clic en"
									},
									{
										"bold": "Configuration (Configuración) → Basic settings (Configuración básica) → Busca Klarna Payment Method"
									}
								],
								[
									{
										"text": "Introduce tus credenciales de la API de Klarna en los campos"
									},
									{
										"bold": "Nombre de usuario de la API de Klarna"
									},
									{
										"text": "y"
									},
									{
										"bold": "Contraseña de la API de Klarna"
									},
									{
										"text": "y guarda los cambios."
									}
								],
								[
									{
										"text": "Comprueba que estés utilizando el modo en vivo y utiliza tus credenciales de la API de Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Configura tu(s) portal(es) del método de pago Klarna",
							"step_instructions": [
								[
									{
										"text": "Antes de utilizar Klarna necesitas activar tu(s) portal(es) del método de pago Klarna. Para encontrarlos haz clic en"
									},
									{
										"bold": "Configuration → Payment methods (Métodos de pago)"
									}
								],
								[
									{
										"text": "Los portales del método de pago Klarna están instalados como opción predeterminada. Abre los portales del método de pago Klarna en los que estés registrado y actívalos. Para ello, haz clic en"
									},
									{
										"bold": "Activar"
									},
									{
										"text": "(en la casilla). Guarda los cambios."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Configura tus costes de envío",
							"step_instructions": [
								[
									{
										"text": "Configura tus costes de envío para tu(s) portal(es) del método de pago Klarna. Para ello, haz clic en"
									},
									{
										"bold": "Configuration → Shipping cost (Coste de envío)"
									}
								],
								[
									{
										"text": "Selecciona los métodos de envío que debería haber disponibles para Klarna. Para ello haz clic en el"
									},
									{
										"bold": "icono del lápiz."
									}
								],
								[
									{
										"text": "Selecciona la pestaña del método de pago y cambia tu(s) portal(es) del método de pago Klarna, de"
									},
									{
										"bold": "Disponible"
									},
									{
										"text": "a"
									},
									{
										"bold": "Seleccionado."
									},
									{
										"text": "Guarda tu configuración"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Activa tu complemento del método de pago Klarna",
							"step_instructions": [
								[
									{
										"text": "Después deberás activar el complemento del método de pago Klarna. Haz clic en"
									},
									{
										"bold": "Configuration → Plugin Manager (Administrador de complementos) → Installed (Instalados)"
									},
									{
										"text": "para acceder al Administrador de complementos."
									}
								],
								[
									{
										"text": "Para activar el complemento haz clic en"
									},
									{
										"bold": "el icono “X”"
									},
									{
										"text": "de color rojo."
									}
								],
								[
									{
										"text": "Se te pedirá si deseas borrar la memoria caché. Haz clic en"
									},
									{
										"bold": "Sí."
									},
									{
										"text": "Ten en cuenta que es necesario borrar la memoria caché y compilar los temas cada vez que haces algún cambio en la configuración del módulo o los métodos de pago de Klarna."
									}
								],
								[
									{
										"text": "Para activar plenamente el complemento del método de pago Klarna, es necesario volver a compilar el tema de la tienda. Haz clic en"
									},
									{
										"bold": "Compilar temas"
									},
									{
										"text": "cuando se te solicite."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Últimos pasos",
							"step_instructions": [
								[
									{
										"text": "Para evitar errores de redondeo asegúrate de tener instalada la extensión bcmath de PHP en tu servidor. Encontrarás la guía"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "aquí"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Reinicia tu backend una vez para comprobar que todas las configuraciones estén disponibles en tu tienda."
									}
								],
								[
									{
										"text": "Comprueba que tus productos de Klarna Payment se visualicen correctamente. Para ello añade un artículo a tu carrito, elige Klarna como método de pago y continúa con el proceso de pago (no emitas el pedido realmente)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Habilita el complemento Klarna Checkout para Shopware",
							"step_instructions": [
								[
									{
										"text": "En primer lugar, comprueba que esté instalado el complemento Klarna Checkout para Shopware (Versión 5.2.17 y posteriores). Si no tienes el complemento, dirígete a"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								],
								[
									{
										"text": "En el paso siguiente necesitarás importar el complemento Klarna Checkout a Shopware. Para ello, haz clic en"
									},
									{
										"bold": "Configuration → Plugin Manager (Administrador de complementos) → Installed (Instalados) → Upload Plugin (Cargar complemento)."
									},
									{
										"text": "Haz clic"
									},
									{
										"bold": "Seleccionar"
									},
									{
										"text": "y selecciona el archivo ZIP de complementos de Klarna Checkout. Para confirmar, haz clic en"
									},
									{
										"bold": "Cargar complemento."
									},
									{
										"text": "Ahora el complemento se puede encontrar en el administrador de complementos."
									}
								],
								[
									{
										"text": "Para instalar el complemento haz clic en"
									},
									{
										"bold": "el icono “+”"
									},
									{
										"text": "de color verde."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Configura el complemento Klarna Checkout para Shopware",
							"step_instructions": [
								[
									{
										"text": "Ve a la configuración de los complementos. Para ello haz clic en"
									},
									{
										"bold": "Configuration → Basic settings (Configuración básica) → Buscar Klarna Checkout"
									}
								],
								[
									{
										"text": "Introduce tus credenciales de la API de Klarna en los campos"
									},
									{
										"bold": "Nombre de usuario de la API de Klarna"
									},
									{
										"text": "y"
									},
									{
										"bold": "Contraseña de la API de Klarna"
									},
									{
										"text": "y guarda los cambios."
									}
								],
								[
									{
										"text": "Comprueba que estés utilizando el modo en vivo y utiliza tus credenciales de la API de Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Activa el portal de pago de Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Antes de utilizar Klarna necesitas activar tu portal de Klarna Payment. Para encontrarlos haz clic en"
									},
									{
										"bold": "Configuration → Payment methods (Métodos de pago)"
									}
								],
								[
									{
										"text": "Abre el portal de Klarna Checkout y actívalo. Para ello haz clic en"
									},
									{
										"bold": "Activar"
									},
									{
										"text": "(en la casilla). Guarda los cambios."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Configura tus costes de envío",
							"step_instructions": [
								[
									{
										"text": "Configura tus costes de envío para tu portal de Klarna Checkout. Para ello, haz clic en"
									},
									{
										"bold": "Configuration → Shipping cost (Coste de envío)"
									}
								],
								[
									{
										"text": "Selecciona los métodos de envío que debería haber disponibles para Klarna. Para ello haz clic en el"
									},
									{
										"bold": "icono del lápiz."
									}
								],
								[
									{
										"text": "Selecciona la pestaña del método de pago y cambia tu Klarna Checkout, de"
									},
									{
										"bold": "Disponible"
									},
									{
										"text": "a"
									},
									{
										"bold": "Seleccionado."
									},
									{
										"text": "Guarda tu configuración"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Activa tu complemento Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Después deberás activar el complemento Klarna Checkout. Haz clic en"
									},
									{
										"bold": "Configuration → Plugin Manager (Administrador de complementos) → Installed (Instalados)"
									},
									{
										"text": "para acceder al Administrador de complementos."
									}
								],
								[
									{
										"text": "Para activar el complemento haz clic en"
									},
									{
										"bold": "el icono “X”"
									},
									{
										"text": "de color rojo."
									}
								],
								[
									{
										"text": "Se te pedirá si deseas borrar la memoria caché. Haz clic en"
									},
									{
										"bold": "Sí."
									}
								],
								[
									{
										"text": "Para activar plenamente el complemento Klarna Checkout, es necesario volver a compilar el tema de la tienda. Haz clic en"
									},
									{
										"bold": "Compilar temas"
									},
									{
										"text": "cuando se te solicite."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Últimos pasos",
							"step_instructions": [
								[
									{
										"text": "Para evitar errores de redondeo asegúrate de tener instalada la extensión bcmath de PHP en tu servidor. Encontrarás la guía"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "aquí"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Comprueba que “Additional address line 1” (Dirección adicional - 1.ª línea) y “Additional address line 2” (Dirección adicional - 2.ª línea) no estén marcados como campos obligatorios."
									}
								],
								[
									{
										"text": "Reinicia tu backend una vez para comprobar que todas las configuraciones estén disponibles en tu tienda."
									}
								],
								[
									{
										"text": "Comprueba que tus productos de Klarna Checkout se visualicen correctamente. Para ello añade un artículo a tu carrito, elige Klarna como método de pago y continúa con el proceso de pago (no emitas el pedido realmente)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Habilita el complemento del método de pago Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Para poder instalar el complemento de Klarna necesitarás un sistema en funcionamiento de Shopware 6. Las instrucciones de instalación se pueden encontrar"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "aquí."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Instalación y configuración. El complemento de Klarna se puede instalar de varias formas.",
							"step_instructions": [
								[
									{
										"text": "Para empezar, ejecuta el asistente."
									}
								],
								[
									{
										"text": "Instalación mediante la administración."
									}
								],
								[
									{
										"text": "Instalación mediante la descarga directa de la tienda comunitaria."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Activa el complemento del método de pago Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Ve a la vista general de tus complementos en el panel de administración de Shopware. Puedes acceder a través de"
									},
									{
										"bold": "Settings (Configuración) > System > Plugins (Complementos)."
									}
								],
								[
									{
										"text": "Seleccionar"
									},
									{
										"bold": "Instala"
									},
									{
										"text": "desde el menú contextual (\"...\"). Recibirás un mensaje de instalación correcta enviado por Shopware indicando que el complemento se ha instalado sin problema."
									}
								],
								[
									{
										"text": "Por motivos de seguridad, el complemento estará instalado pero no activado todavía. Antes deberás optimizarlo con tus datos de acceso y configuración individual."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Asistente",
							"step_instructions": [
								[
									{
										"text": "Una vez activado el complemento, ve al"
									},
									{
										"bold": "menú contextual (\"...\") > asistente.",
										"text": "Esto te dirigirá a la rutina."
									}
								],
								[
									{
										"text": "La rutina te guiará a través de todo el proceso de configuración y permite que te registres en Klarna si no tienes una cuenta de distribuidor todavía."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Configuración del complemento",
							"step_instructions": [
								[
									{
										"bold": "canales de venta."
									},
									{
										"text": "Aquí puedes determinar si la configuración siguiente debe ser para \"todos los canales de venta\" o se debe aplicar únicamente a ciertos canales de venta individuales."
									}
								],
								[
									{
										"bold": "Configuración de la API."
									},
									{
										"text": "Nombre de usuario de la API y contraseña de la API. Especifica tus datos de acceso a la API aquí para el modo de prueba y el modo real en las secciones correspondientes."
									}
								],
								[
									{
										"text": "Para probar tus credenciales de la API de Klarna puedes hacer clic en"
									},
									{
										"bold": "el botón Probar credenciales de API,",
										"text": "que se encuentra en el encabezado. Recibirás entonces un mensaje confirmando el funcionamiento correcto o indicando qué datos no parecen correctos."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Activar/desactivar complemento",
							"step_instructions": [
								[
									{
										"text": "Si deseas activar/desactivar el complemento del método de pago Klarna o solo deseas ver el estado de activación actual dirígete a Shopware Admin y selecciona"
									},
									{
										"bold": "Settings (Configuración) > System > Plugins (Complementos)."
									}
								],
								[
									{
										"text": "Aquí puedes consultar el estado actual en la tabla debajo de"
									},
									{
										"bold": "\"My Plugins\" (Mis complementos)."
									}
								],
								[
									{
										"text": "Para cambiar el estado haz clic en el botón deslizante."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						},
						{
							"title": "Últimos pasos",
							"step_instructions": [
								[
									{
										"text": "Para evitar errores de redondeo asegúrate de tener instalada una versión de PHP  >= 7.2."
									}
								],
								[
									{
										"text": "Finaliza la instalación de Shopware"
									},
									{
										"bold": "(Storefront + Administration, no sin encabezado)."
									}
								],
								[
									{
										"text": "El sistema debe ser accesible desde el exterior para actualizar el estado del pago."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de Shopware, consulta su"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guía ampliada (en alemán)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de 3dcart, sigue la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Activar el método de pago Klarna en el Online Store Manager (Gestor de la tienda en línea)",
							"step_instructions": [
								[
									{
										"text": "Inicia sesión en tu"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "Online Store Manager de 3dcart"
									},
									{
										"text": "y dirígete a"
									},
									{
										"bold": "Settings (Configuración) → Payment (Pago)."
									}
								],
								[
									{
										"text": "En la página Payment (Pago), haz clic en"
									},
									{
										"bold": "Seleccionar métodos de pago"
									},
									{
										"text": "(en el botón)."
									}
								],
								[
									{
										"text": "Verás una lista de los módulos preinstalados. Localiza el módulo de Klarna y actívalo mediante el botón conmutador."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de 3dcart, sigue la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Introduce tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Una vez activado el módulo, introduce tu nombre de usuario de la API de Klarna (UID) en el campo correspondiente. Lo encontrarás en el fichero de las credenciales que descargaste previamente."
									}
								],
								[
									{
										"text": "Después, haz clic en el"
									},
									{
										"bold": "enlace Cambiar la contraseña"
									},
									{
										"text": "e introduce tu contraseña de la API de Klarna en el campo de la contraseña."
									}
								],
								[
									{
										"text": "Debajo del"
									},
									{
										"bold": "Código de país"
									},
									{
										"text": "selecciona el idioma del país que se utilizará para las opciones de pago de Klarna en la tienda."
									}
								],
								[
									{
										"text": "Encima del campo del nombre de usuario hay una casilla con la etiqueta"
									},
									{
										"bold": "\"Test Mode\" (Modo de prueba)."
									},
									{
										"text": "Marca esta opción para activar el modo de prueba y poder emitir pedidos sin tener que hacer ningún pago mientras estás probando el módulo."
									}
								],
								[
									{
										"text": "Cuando hayas terminado de configurar tus parámetros, haz clic en \"Save\" (Guardar) en la esquina superior derecha."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de 3dcart, sigue la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guía de integración ampliada."
									}
								]
							]
						},
						{
							"title": "Haz una compra de prueba",
							"step_instructions": [
								[
									{
										"text": "Para verificar que la integración esté configurada correctamente, haz una compra de prueba en tu tienda."
									}
								],
								[
									{
										"text": "Después de emitir el pedido ve a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Pedidos en el Portal del comercio,"
									},
									{
										"text": "busca tu pedido y cancélalo para no tener que pagarlo."
									}
								],
								[
									{
										"text": "Una vez finalizada tu integración correctamente, el banner de la parte superior de esta página cambiará a verde y mostrará el texto \"Integration Completed\"."
									}
								],
								[
									{
										"text": "Si activaste el “Test Mode” (Modo de prueba) en el paso anterior, retrocede para desmarcar esta opción y guardar antes del lanzamiento real en tu tienda, para que los pedidos reales se procesen correctamente."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para más información sobre la integración de 3dcart, sigue la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guía de integración ampliada."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							],
							"alternate": [
								{
									"text": "Para más información sobre la integración de BigCommerce, sigue la"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guía de integración ampliada."
								}
							]
						},
						{
							"title": "Configura tus parámetros de BigCommerce",
							"step_instructions": [
								[
									{
										"text": "En BigCommerce, dirígete a"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Store Setup (Configuración de tienda) › Payments (Pagos),"
									},
									{
										"text": "y amplía la sección Métodos de pago en línea. Después haz clic en"
									},
									{
										"bold": "Configurar"
									},
									{
										"text": "junto al método de pago Klarna"
									}
								],
								[
									{
										"text": "Te conducirá a la pestaña de configuración del método de pago Klarna. Introduce las credenciales de la API que guardaste en la sección anterior y copia el nombre de usuario y la contraseña en los campos correspondientes."
									}
								],
								[
									{
										"text": "Guarda los cambios al terminar."
									}
								]
							],
							"alternate": [
								{
									"text": "Para más información sobre la integración de BigCommerce, sigue la"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guía de integración ampliada."
								}
							]
						},
						{
							"title": "Haz una compra de prueba",
							"step_instructions": [
								[
									{
										"text": "Para verificar que la integración esté configurada correctamente, haz una compra de prueba en tu tienda."
									}
								],
								[
									{
										"text": "Después de emitir el pedido ve a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Pedidos en el Portal del comercio,"
									},
									{
										"text": "busca tu pedido y cancélalo para no tener que pagarlo."
									}
								],
								[
									{
										"text": "Una vez finalizada tu integración correctamente, el banner de la parte superior de esta página cambiará a verde y mostrará el texto \"Integration Completed\"."
									}
								]
							],
							"alternate": [
								{
									"text": "Para más información sobre la integración de BigCommerce, sigue la"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guía de integración ampliada."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Activa el módulo Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Primero, comprueba que esté instalado el módulo oficial de Klarna para Prestashop. Si no lo tienes, dirígete a"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								],
								[
									{
										"text": "Lamentablemente, a partir del 1 de enero de 2023, estos complementos desarrollados por y propiedad de Prestasworks A.B (SI) dejarán de distribuirse de forma gratuita. Si estás interesado en Klarna, puedes comprar estos complementos o esperar a que Klarna lance los suyos propios, previstos para el segundo trimestre de 2023."
									}
								],
								[
									{
										"text": "Inicia sesión en la página de administración de Prestashop y dirígete a"
									},
									{
										"bold": "Modules → Modules."
									}
								],
								[
									{
										"text": "Busca “Klarna” en la barra de búsquedas para localizar el módulo de Klarna de Prestaworks AB. Haz clic en"
									},
									{
										"bold": "Configure (Configurar)."
									}
								]
							]
						},
						{
							"title": "Configura tus parámetros del módulo de Klarna",
							"step_instructions": [
								[
									{
										"text": "Ahora te encuentras en la página de configuración del módulo. En la parte superior de “General settings” (Configuración general) habrá un botón denominado"
									},
									{
										"bold": "Activate KCO in this shop (Activar KCO en esta tienda)"
									},
									{
										"text": "(Klarna Checkout V3). Elige"
									},
									{
										"bold": "Sí."
									}
								],
								[
									{
										"text": "Haz clic"
									},
									{
										"bold": "Guardar"
									},
									{
										"text": "para guardar tu configuración."
									}
								],
								[
									{
										"text": "Después, haz clic en el país de tus ventas, a la izquierda del menú, e introduce las credenciales de la API de Klarna en"
									},
									{
										"bold": "Nombre de usuario de la API de Klarna"
									},
									{
										"text": "y"
									},
									{
										"bold": "Contraseña de la API de Klarna."
									}
								],
								[
									{
										"text": "Haz clic en"
									},
									{
										"bold": "Guardar"
									}
								]
							]
						},
						{
							"title": "Últimos pasos",
							"step_instructions": [
								[
									{
										"text": "Comprueba que el modo de prueba esté desactivado si lo tienes todo listo para funcionar públicamente en tu sitio. Puedes hacerlo desde la pestaña"
									},
									{
										"bold": "Configuración habitual."
									},
									{
										"text": "El botón"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "debe estar establecido en"
									},
									{
										"bold": "No."
									}
								],
								[
									{
										"text": "Todavía en"
									},
									{
										"bold": "Configuración habitual,"
									},
									{
										"text": "recuerda establecer tu configuración sobre manejo de los pedidos, parámetros de envío de facturas, etc."
									}
								],
								[
									{
										"text": "Comprueba que Klarna Checkout se muestre de la forma prevista. Para ello, añade un artículo a tu carrito y sigue el proceso de pago (no emitas el pedido realmente)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							]
						},
						{
							"title": "Instala y activa el módulo del método de pago Klarna",
							"step_instructions": [
								[
									{
										"text": "Abre la"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "página de instrucciones de Prestashop para el método de pago Klarna"
									},
									{
										"text": "y sigue las instrucciones que se indican para instalar y configurar el módulo en tu cuenta Prestashop."
									}
								]
							]
						},
						{
							"title": "Haz una compra de prueba",
							"step_instructions": [
								[
									{
										"text": "Para verificar que la integración esté configurada correctamente, haz una compra de prueba en tu tienda."
									}
								],
								[
									{
										"text": "Después de emitir el pedido ve a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Pedidos en el Portal del comercio,"
									},
									{
										"text": "busca tu pedido y cancélalo para no tener que pagarlo."
									}
								],
								[
									{
										"text": "Una vez finalizada tu integración correctamente, el banner de la parte superior de esta página cambiará a verde y mostrará el texto \"Integration Completed\"."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Genera tus credenciales de la API de Klarna.",
							"step_instructions": [
								[
									{
										"text": "Necesitarás estas credenciales para integrar Klarna en tu tienda."
									}
								]
							]
						},
						{
							"title": "Añade Klarna como nuevo método de pago.",
							"step_instructions": [
								[
									{
										"text": "Accede a Jumpseller Admin Panel y navega a Configuración > Pagos, busca “Klarna” en la lista de selección y clica en “Add Method”."
									}
								]
							]
						},
						{
							"title": "Configura nuestro nuevo método de pago.",
							"step_instructions": [
								[
									{
										"text": "En el panel de configuración de Klarna (Jumpseller Admin Panel navega a Configuración > Pagos > Klarna), (i) añade las credenciales de API de Klarna generadas en el primer paso, (ii) selecciona los paquetes EMD que deseas/necesitas compartir con Klarna, y (iii) selecciona si necesitas captar automáticamente los pedidos (la opción predeterminada es no hacerlo)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integra Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Consulta la guía de integración en"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Inglés"
									},
									{
										"text": "y en"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Neerlandés"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integrar Shoper",
							"step_instructions": [
								[
									{
										"text": "Consulta la guía de integración en"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "la web de Shoper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integrar Timma",
							"step_instructions": [
								[
									{
										"text": "Consulta la guía de integración en"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "la página web de Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							]
						},
						{
							"title": "Intégralo con SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Sigue las instrucciones"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "de la web de SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Genera y guarda tus credenciales de la API de Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuevas credenciales de la API y descarga el fichero en tu ordenador. Abre el fichero y no lo cierres, ya que necesitarás estas credenciales de la API en la sección siguiente."
									}
								]
							]
						},
						{
							"title": "Intégralo con Workstand",
							"step_instructions": [
								[
									{
										"text": "Sigue las instrucciones"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "de la web de Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Lee la documentación de nuestro plugin",
							"step_instructions": [
								[
									{
										"text": "Ve a nuestra"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "página de documentación"
									}
								]
							]
						},
						{
							"title": "Activa el módulo de pago de Klarna para JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Comprueba que esté instalada la extensión oficial de Klarna. Si no la tienes,"
									},
									{
										"text": "ve a"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Lee la documentación de nuestro plugin",
							"step_instructions": [
								[
									{
										"text": "Ve a nuestra"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "página de documentación"
									}
								]
							]
						},
						{
							"title": "Activa el módulo de pagos de Klarna para JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Comprueba que esté instalada la extensión oficial de Klarna. Si no la tienes,"
									},
									{
										"text": "ve a"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "esta página"
									},
									{
										"text": "para obtenerlo."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Después, sigue los pasos siguientes",
							"step_instructions": [
								[
									{
										"bold": "Genera tus credenciales de la API de Klarna."
									},
									{
										"text": "Necesitarás estas credenciales para integrar Klarna en tu tienda."
									}
								],
								[
									{
										"bold": "Añade las credenciales de la API de Klarna API en tu sistema de backend para habilitar Klarna."
									},
									{
										"text": "Explora nuestro"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Portal de desarrolladores"
									},
									{
										"text": "para más información."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Nombre",
							"error": "Indica un nombre"
						},
						"last_name": {
							"label": "Apellido",
							"error": "Indica un apellido"
						},
						"dateOfBirth": {
							"label": {
								"default": "Fecha de nacimiento (DD/MM/AAAA)",
								"without_format": "Fecha de nacimiento",
								"US": "Fecha de nacimiento (MM/DD/AAAA)"
							},
							"error": "Indica una fecha válida",
							"error_too_young": "Debes tener al menos 18 años para vender con Klarna"
						},
						"address": {
							"label": "Dirección particular",
							"error": "Indica una dirección"
						},
						"city": {
							"label": "Ciudad",
							"error": "Indica una ciudad"
						},
						"country": {
							"label": "País",
							"error": "Selecciona un país"
						},
						"postal_code": {
							"label": {
								"default": "Código postal",
								"US": "Código postal"
							},
							"error": {
								"default": "Indica un código postal válido",
								"US": "Indica un código postal válido"
							}
						},
						"region": {
							"label": "Estado/región (opcional)",
							"label_summary": "Estado/región"
						},
						"state": {
							"label": "Estado",
							"error": "Indica un estado"
						},
						"role_question": {
							"OWNER": "¿Esta persona es un titular?",
							"BENEFICIAL_OWNER": "¿Posee esta persona el control de más del 25 % de las acciones con derecho a voto?",
							"ULTIMATE_BENEFICIAL_OWNER": "Esta persona posee o controla más del 25 % de las acciones con derecho a voto"
						},
						"is_person_pep": [
							{
								"text": "¿Esta persona es"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "una persona expuesta políticamente (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "un familiar"
							},
							{
								"text": "o"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "un colaborador conocido"
							},
							{
								"text": "de dicha persona?"
							}
						],
						"pep_relationship": {
							"label": "Relación",
							"error": "Selecciona la relación que tiene esta persona con una PEP"
						},
						"pep_position": {
							"label": "Cargo de la PEP",
							"error": "Selecciona el cargo que ocupa la PEP"
						},
						"personal_id_question": "Esta persona no tiene un Número de Identificación Personal",
						"personal_id": {
							"US": {
								"label": "Número de la Seguridad Social (últimos 4 dígitos)",
								"label_summary": "Número de la Seguridad Social"
							},
							"US_FULL_SSN": {
								"label": "Número de la Seguridad Social",
								"label_summary": "Número de la Seguridad Social"
							},
							"CA": {
								"label": "Número del Seguro Social (SIN) o Número de pasaporte",
								"label_summary": "Número del Seguro Social (SIN) o Número de pasaporte"
							},
							"SE": {
								"label": "Número de Identificación Personal (PNO)",
								"label_summary": "Número de Identificación Personal (PNO)"
							},
							"FI": {
								"label": "Código de Identificación Personal (HETU)",
								"label_summary": "Número de Identificación Personal (HETU)"
							},
							"NO": {
								"label": "Número de Identidad Nacional",
								"label_summary": "Número de Identidad Nacional"
							},
							"DK": {
								"label": "Número de Identificación Personal",
								"label_summary": "Número de Identificación Personal (CPR)"
							},
							"IT": {
								"label": "Código fiscal",
								"label_summary": "Código fiscal"
							},
							"ES": {
								"label": "Número de Identificación Personal",
								"label_summary": "Número de identidad (DNI)"
							},
							"PL": {
								"label": "Número de Identificación Personal",
								"label_summary": "Número de Identificación Personal (PESEL)"
							},
							"default": {
								"label": "Número de pasaporte",
								"label_summary": "Número de pasaporte"
							},
							"value": "Confidencial"
						},
						"registration_number": {
							"label": "Número de Identificación de la Empresa",
							"error": "Indica el EIN en el formato siguiente: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Nombre de la tienda",
							"error": "Indica un nombre de empresa válido"
						},
						"legal_company_name": {
							"label": "Denominación legal de la empresa",
							"error_label": "Indica la denominación legal de la empresa"
						},
						"add_person": "Añadir persona",
						"remove": "Eliminar",
						"edit": "Editar"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "ID del comerciante: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Material de marketing",
						"text": "¡Ya formas parte de la familia Klarna! Te ofrecemos un varios documentos y materiales para seguir adelante.",
						"link": "Descargar"
					},
					"invite_more_users": {
						"title": "Invita a nuevos usuarios",
						"text": "Invita a tus colaboradores al Portal del comercio. Podrás personalizar los permisos para cada uno.",
						"link": "Invitar a usuarios"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Productos y precios",
					"subtitle": "{country}",
					"pricing": "Precios para {country}",
					"monthly_fee": "comisión mensual",
					"transaction_fee": "comisión por transacción",
					"before_link": "Acepto las",
					"link_text": "Condiciones generales",
					"after_link_one_product": "de este producto",
					"after_link_more_than_one_product": "de estos productos",
					"product_not_available_in_your_country": "* Este producto no está disponible en tu mercado nacional, pero funcionará en otros países."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Instalado"
						},
						"in_progress": {
							"text": "Se está procesando"
						}
					}
				},
				"phone_collection_block": {
					"title": "¿Tienes problemas con tu integración de Klarna?",
					"description": "Indica tu número a continuación y te llamará uno de nuestros agentes para ayudarte a añadir Klarna a tu e-commerce.",
					"success_banner": "¡Gracias! Nuestro equipo te contactará lo antes posible.",
					"submit": "Enviar",
					"fields": {
						"phone": {
							"label": "Número de teléfono",
							"tooltip": "Debes incluir el código del país, por ej., +1 541 754 3010",
							"errors": {
								"required": "El número de teléfono es obligatorio",
								"invalid": "Número de teléfono no válido"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "¿Quién firma los contratos de tu empresa?",
						"managed": "¿Quién firma los contratos de la empresa?",
						"recollection": "¿Quién tiene el poder de firmar en nombre de tu empresa?"
					},
					"subtitle": {
						"unmanaged": "Tu empresa se dispone a cerrar un contrato con Klarna. Debemos verificar quién tiene la autorización legal para firmar contratos.",
						"managed": "Debes facilitar los datos de todas las personas con poder de firma de la empresa que formalizan el acuerdo. Tenemos la obligación legal de validar el poder de firma de estas personas representantes. Si una de las personas enumeradas firmó el acuerdo, haz clic en “Añadir persona” y facilita los datos que se piden.",
						"recollection": "Tu empresa tiene un acuerdo en vigor con Klarna y la ley nos obliga en estos casos a recopilar y verificar la información de todos tus representantes legales."
					},
					"form_title": "Facilita la información",
					"robot_message": {
						"unmanaged": "Suelen ser los consejeros del consejo de administración o directivos como el CEO, el CFO o el COO. Para acelerar el proceso de aprobación del contrato añade a dos o más personas.",
						"managed": "Suelen ser los consejeros del consejo de administración o directivos como el CEO, el CFO o el COO. Para acelerar el proceso de aprobación del contrato añade a dos o más personas."
					},
					"error_tooltip": {
						"too_young": "Esta persona no puede enviar la solicitud por ser menor de {minAge} años."
					},
					"alert_all_too_young": "Todas las personas que formalicen el acuerdo deben ser mayores de {minAge}. Para continuar añade y selecciona a un solicitante mayor de {minAge}.",
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás",
						"add_person": "+ Añadir persona"
					},
					"role": {
						"recollection": "Representante legal"
					}
				},
				"application_summary": {
					"title": "Revisa tu solicitud y envíala.",
					"subtitle": {
						"unmanaged": "Repasa tus datos antes de enviar esto.",
						"managed": "Repasa los datos antes de enviar esto."
					},
					"stakeholders": {
						"title": "Administración de la empresa",
						"subtitle": "Accionista {index}"
					},
					"businessDetailsCard": {
						"title": "Datos de la empresa"
					},
					"businessDetailsCardFields": {
						"companyName": "Nombre de la empresa",
						"organizationEntityType": "Clasificación fiscal",
						"organizationRegistrationAuthority": "Tribunal de registro",
						"goodsCategory": "Categoría de mercancías",
						"registrationId": {
							"default": "Número de inscripción en el registro",
							"AT": "Número de inscripción en el registro",
							"AU": "ACN",
							"CA": "Número de empresa",
							"ES": "NIF/NIE/DNI de la empresa",
							"GB": "Número de organización",
							"GR": "Número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)",
							"NZ": "Número de empresa",
							"US": "Número de Identificación de Empresa"
						},
						"registered": {
							"default": "Empresa registrada",
							"AU": "La empresa tiene un ACN"
						},
						"subjectToVat": {
							"default": "La empresa está sujeta a IVA",
							"AU": "La empresa está sujeta a ABN"
						},
						"vatId": {
							"default": "NIF",
							"AU": "ABN",
							"NZ": "Número de GST",
							"ES": "NIF/NIE/DNI de la empresa"
						},
						"storeName": "Nombre de la tienda",
						"storeName_us": "Nombre de la marca / DBA",
						"website": "Sitio web",
						"email": "Correo electrónico de ayuda para el cliente",
						"entityType": "Tipo de entidad"
					},
					"companyRegistrationAddressCard": {
						"title": "Domicilio social de la empresa"
					},
					"companyAddressCard": {
						"title": "Dirección de la empresa"
					},
					"operatingAddressCard": {
						"title": "Dirección de la empresa operativa"
					},
					"documentsCard": {
						"title": "Documentos cargados"
					},
					"buttons": {
						"edit": "Editar",
						"back": "Atrás",
						"submit": "Enviar"
					},
					"noTermsAccepted": "Lee y acepta las condiciones generales",
					"noTermsAcceptedWithPricingAnnex": "Lee y acepta el Acuerdo del Comercio y las Condiciones de precios"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "¿Quién dirige la empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Es un requisito legal. En virtud de la directiva contra el blanqueo de capitales de la UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						],
						"US": [
							{
								"text": "Como entidad financiera, tenemos la obligación legal de recopilar esta información."
							}
						],
						"CA": [
							{
								"text": "Como entidad financiera, tenemos la obligación legal de recopilar esta información."
							}
						],
						"AU": [
							{
								"text": "Como entidad financiera, tenemos la obligación legal de recopilar esta información."
							}
						]
					},
					"infobox": {
						"default": "Indica los datos personales y el domicilio particular del CEO de la empresa.",
						"US": "Indica la información personal y la dirección particular del accionista mayoritario o un directivo de alto nivel, como el CEO, CFO o COO.",
						"CA": "Indica la información personal y la dirección particular del accionista mayoritario o un directivo de alto nivel, como el CEO, CFO o COO."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "¿Es una empresa de titularidad pública o solamente de titularidad privada?",
					"title_stakeholder": "¿Quién dirige la empresa?",
					"subtitle": "Como entidad financiera tenemos la obligación legal de recopilar esta información.",
					"subtitle_stakeholder": "Indica los datos personales y el domicilio particular del CEO de la empresa.",
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"bank_account": {
					"title": {
						"default": "Indica los datos de tu cuenta bancaria"
					},
					"subtitle": {
						"US": "Las transacciones de Klarna se transferirán a esta cuenta bancaria.",
						"default": "Utilizaremos estos datos bancarios para transferir los pagos de tus ventas."
					},
					"no_more_bank_accounts": "Ya has añadido los datos de cuentas bancarias para todas las monedas compatibles. ¡Buen trabajo!",
					"robot_message_general": "La cuenta bancaria predeterminada debe ser de un banco del país en el que está registrada tu empresa. También deberás añadir una cuenta bancaria por cada nuevo país en el que tengas previsto que te acepten.",
					"robot_message": "Las siglas IBAN significan International Bank Account Number y es un número facilitado por tu banco para tu cuenta. Por ej.: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "El banco proporciona el número de cuenta, que tiene entre 6 y 10 dígitos. Por ej.: 12345678",
						"US": "El banco proporciona el número de cuenta, que tiene entre 5 y 17 dígitos. Por ej.: 12345678",
						"GB": "El número de cuenta lo facilita tu banco y tiene 8 dígitos. Por ej.: 12345678. Algunos bancos del Reino Unido usan números de cuenta más cortos (es decir, de 7 dígitos). En este caso, se añadirán ceros al principio de tu número para que tenga 8 dígitos."
					},
					"robot_message_revolut": "El IBAN que has facilitado no puede recibir pagos en GBP nacionales. Deberás contactar con tu banco y solicitar los datos de la cuenta compatible con las transferencias de GBP nacionales.",
					"robot_message_local": "El IBAN que has facilitado es local de tu banco y no es compatible con nuestro sistema. Deberás contactar con tu banco y solicitar tu IBAN personal o usar otra cuenta para conectarla a Klarna.",
					"buttons": {
						"add_bank_account": "+ Añadir cuenta bancaria",
						"skip": "Omitir (por ahora)",
						"remove": "Eliminar",
						"submit": "Enviar",
						"next": "Siguiente",
						"back": "Atrás"
					},
					"fields": {
						"currency_code": {
							"label": "Moneda",
							"disable_reason": {
								"account_in_merchant_currency_required": "La divisa predeterminada es {currency} debido al país en que tu empresa está registrada."
							},
							"errors": {
								"general": "Selecciona una moneda"
							}
						},
						"country_of_bankaccount": {
							"label": "País",
							"errors": {
								"general": "Selecciona un país"
							}
						},
						"iban_account_number": {
							"label": "Número de cuenta (IBAN)",
							"errors": {
								"general": "Indica un número de cuenta bancaria (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Usa esta cuenta para divisas indeterminadas",
							"tooltip": "Los pedidos con divisas que no figuran en esta página se pagarán a esta cuenta. Tu banco puede cobrar una tarifa adicional por algunas divisas."
						},
						"local_account_number": {
							"label": {
								"default": "Número de cuenta",
								"MX": "Número CLABE"
							},
							"errors": {
								"general": {
									"default": "Especifica un número de cuenta bancaria",
									"MX": "Indica un número CLABE válido"
								}
							}
						},
						"account_holder": {
							"label": "Nombre del titular de la cuenta",
							"errors": {
								"general": "Introduce el nombre del titular de la cuenta (máximo 70 caracteres)."
							}
						},
						"transit_number": {
							"label": "Número de tránsito",
							"errors": {
								"general": "Indica un número de tránsito válido"
							}
						},
						"institution_number": {
							"label": "Número de entidad",
							"errors": {
								"general": "Indica un número de entidad válido"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Especifica una sucursal bancaria estatal (BSB) válida"
								}
							},
							"tooltip": {
								"AU": "El código B2B contiene 6 números separados por -. P. ej.: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Número de ruta",
								"GB": "Número de agencia"
							},
							"errors": {
								"general": {
									"default": "Indica un número de ruta válido",
									"GB": "Indica un número de agencia válido"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "¿Quién dirige la empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Es un requisito legal. En virtud de la directiva contra el blanqueo de capitales de la UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						],
						"GB": [
							{
								"text": "Tenemos la obligación legal de recopilar esta información. Comprueba que tu inscripción en el Registro Mercantil esté actualizada."
							}
						]
					},
					"infobox": "Indica la información personal y la dirección particular de la persona que ejerce el control de la administración de tu empresa, como el director general o los consejeros.",
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás",
						"add_person": "+ Añadir persona"
					},
					"messages": {
						"lookup": "¿Estas personas dirigen tu empresa? Repasa lo siguiente y confirma si es correcto."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "¿Es tu negocio una empresa registrada?",
						"managed": "¿Está vuestra empresa inscrita en el Registro Mercantil?"
					},
					"subtitle": {
						"unmanaged": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
						"managed": "Necesitamos el NIF para verificar los datos de la empresa."
					},
					"question": {
						"title": {
							"unmanaged": "Indica tu número de registro y tu tribunal de registro",
							"managed": "Indica tu NIF y tu tribunal de registro"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Número de inscripción en el registro"
						},
						"registration_court": {
							"label": "Tribunal de registro",
							"errors": {
								"general": {
									"unmanaged": "Selecciona tu tribunal de registro",
									"managed": "Selecciona el tribunal de registro"
								}
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"documents": {
					"title": "Adjunta tus documentos",
					"subtitle": "Necesitamos que nos envíes algunos documentos adicionales para validar tu identidad. Carga solo archivos <strong>JPG</strong>, <strong>PNG</strong> o <strong>PDF</strong> (con un tamaño máximo de 10 MB).",
					"subheadline": {
						"default": "Klarna es un banco con sede matriz en Suecia y por lo tanto regulado bajo el control de la Autoridad de Supervisión Financiera de Suecia, que debe cumplir con la Directiva de la Unión Europea EU 2015/849. Klarna necesita recopilar información sobre aquellos personas que controlan o son beneficiarios de la empresa para poder usar nuestros servicios. Por favor, adjunta sólo documentos <strong>JPG, PNG o archivos PDF</strong> (tamaño máximo 10 MB).",
						"US": "Como Klarna es un banco con sede en Suecia y, por lo tanto, está bajo el control de la Autoridad de supervisión financiera de Suecia, Klarna debe cumplir con la Directiva europea EU 2015/849. Klarna está obligada a recopilar información sobre las personas que controlan la empresa antes de poder comenzar a utilizar los servicios de Klarna. Facilítanos la siguiente documentación para que verifiquemos tu identidad. Carga solo archivos JPG, PNG o PDF (con un tamaño máximo de 10 MB).",
						"IT": "Como Klarna es un banco con sede en Suecia y, por lo tanto, está bajo el control de la Autoridad de supervisión financiera de Suecia, Klarna debe cumplir con la Directiva europea EU 2015/849. Klarna necesita recopilar información sobre las personas que controlan la empresa, antes de poder comenzar a utilizar los servicios de Klarna. Ten en cuenta que para proceder con la aplicación, tu empresa debe estar registrada en la Cámara de Comercio. Carga solo archivos JPG, PNG o PDF (con un tamaño máximo de 10 MB)."
					},
					"header_title": "Documentos",
					"stakeholder": "Accionista",
					"business_documents": "Documentos empresariales",
					"browse_files": "Explorar archivos",
					"optional": "(opcional)",
					"upload_area": {
						"title": {
							"before_link": "Suelta aquí tus archivos o",
							"link_text": "Selecciona archivos"
						},
						"description": "{acceptedFileFormats} - Máximo {maxFileSizeMB} MB por archivo"
					},
					"description": {
						"APPROVAL": "Cargar <strong>aprobación</strong>",
						"CONTRACT": "Cargar <strong>contrato</strong>",
						"CORRECTION_NOTE": "Cargar <strong>nota de corrección</strong>",
						"COUNTERSIGNED_CONTRACT": "Cargar <strong>contrato refrendado</strong>",
						"ID_DOCUMENT": "Cargar <strong>documento de identidad</strong> o <strong>pasaporte</strong>",
						"LICENSE": "Cargar <strong>carnet</strong>",
						"PROOF_OF_ADDRESS": "Cargar <strong>comprobante de domicilio</strong>",
						"SPECIAL_AGREEMENT": "Cargar <strong>acuerdo especial</strong>",
						"SUPPORTING_DOCUMENT": "Cargar <strong>documento de respaldo</strong>",
						"TAX_OFFICE_REGISTRATION": "Cargar <strong>inscripción en agencia tributaria</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Aprobación"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Contrato"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Correction note"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Contrato Firmado"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Prueba de identidad",
								"IT": "Documento de identidad"
							},
							"subtitle": {
								"default": "Por favor adjunta ambos lados de tu tarjeta de identidad.",
								"AT": "Facilítanos ambas caras de tu documento de identidad. Si tu dirección no figura en el documento de identidad, necesitaremos documentación adicional, como una factura de suministros, para verificarla.",
								"AU": "Para agilizar la evaluación de la solicitud, facilítanos una copia válida de un documento de identidad con fotografía, como el pasaporte o el permiso de conducir australiano, de los siguientes socios de la empresa: Empresario individual: el propietario. Empresa: el representante legal, todos los directivos y cualquier parte interesada que posea más del 25 % de las acciones.",
								"BE": "Facilítanos ambas caras del documento de identidad, asegúrate de que la imagen sea lo suficientemente clara y de que toda la información sea legible.",
								"DE": "Facilítanos ambas caras de tu documento de identidad. Si tu dirección no figura en el documento de identidad, necesitaremos documentación adicional, como una factura de suministros, para verificarla.",
								"FR": "Facilítanos ambas caras del documento de identidad, asegúrate de que la imagen sea lo suficientemente clara y de que toda la información sea legible.",
								"GB": "Facilita el documento de identifidad, si es una tarjeta de identidad, por ambas caras.",
								"IT": "La parte delantera/trasera de un documento de identidad válido de las personas enumeradas en la aplicación. No se acepta el permiso de conducir, el pasaporte, la tarjeta/número de la seguridad social.",
								"NL": "Facilítanos ambas caras del documento de identidad, asegúrate de que la imagen sea lo suficientemente clara y de que toda la información sea legible.",
								"US": "Permiso de conducir o pasaporte: facilita ambas caras del documento de identidad."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Licencia"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Prueba de domicilio personal",
								"BE": "Prueba de domicilio personal",
								"CZ": "Prueba de domicilio personal",
								"ES": "Prueba de domicilio personal",
								"FI": "Prueba de domicilio personal",
								"FR": "Prueba de domicilio personal",
								"GR": "Prueba de domicilio personal",
								"IT": "Prueba de domicilio personal",
								"NL": "Prueba de domicilio personal",
								"PL": "Prueba de domicilio personal",
								"PT": "Prueba de domicilio personal"
							},
							"subtitle": {
								"default": "Aceptamos los siguientes documentos como prueba de domicilio personal (inferiores a 3 meses): Factura de electricidad, agua, gas o Wi-Fi / Declaración de la renta / Contrato de Alquiler. En caso de no tener ninguno de estos documentos a tu nombre, adjunta otra prueba de domicilio personal y una nota con el motivo.",
								"AU": "Para agilizar la evaluación de la solicitud, facilítanos uno de los siguientes documentos con un antigüedad no superior a 90 días para verificar tu domicilio: Factura de servicios, factura de internet, declaración de impuestos o contrato de arrendamiento/alquiler. * Este paso es obligatorio si vas a utilizar el pasaporte como documento de identidad acreditativo o si tu dirección actual no concuerda con la dirección que figura en el documento de identificación.",
								"BE": "Aceptamos los siguientes documentos, con una antigüedad no superior a 3 meses, como prueba de domicilio: Facturas de electricidad, agua o gas; declaración de impuestos o contrato de alquiler. Si no tienes ninguno de estos documentos, carga cualquier otra prueba de domicilio y añade una nota con el motivo.",
								"FR": "Aceptamos los siguientes documentos, con una antigüedad no superior a 3 meses, como prueba de domicilio: Facturas de electricidad, agua o gas; declaración de impuestos o contrato de alquiler. Si no tienes ninguno de estos documentos, carga cualquier otra prueba de domicilio y añade una nota con el motivo.",
								"NL": "Aceptamos los siguientes documentos, con una antigüedad no superior a 3 meses, como prueba de domicilio: Facturas de electricidad, agua o gas; declaración de impuestos o contrato de alquiler. Si no tienes ninguno de estos documentos, carga cualquier otra prueba de domicilio y añade una nota con el motivo.",
								"US": "Aceptamos facturas de servicios (gas, agua, internet, teléfono, etc.), alquiler o hipoteca con prueba de domicilio (antigüedad no superior a 90 días desde la fecha de solicitud).",
								"IT": "Si en tu documento de identidad figura una dirección distinta a la de tu domicilio actual, necesitaremos un documento adicional para verificar tu lugar de residencia. Aceptamos los siguientes documentos, con una antigüedad no superior a 3 meses, como prueba de domicilio de las personas enumeradas en la aplicación:"
							},
							"list": {
								"IT": [
									{
										"text": "Certificado de residencia emitido en línea (mediante SPID) o por el ayuntamiento de tu lugar de residencia"
									},
									{
										"text": "Facturas de electricidad/agua/gas/internet"
									},
									{
										"text": "Contrato de alquiler"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Acuerdo especial"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Documento adicional",
								"GB": "Autofoto"
							},
							"subtitle": {
								"default": null,
								"AU": "Si vendes artículos de marcas de valor elevado, facilítanos 2-3 facturas de proveedores de dichos productos. Asegúrate de que la factura incluye los productos adquiridos, el nombre del proveedor, el nombre de los destinatarios y la dirección de entrega.",
								"GB": "Realiza una autofoto sosteniendo el documento de identidad."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Documento de alta en la agencia tributaria",
								"AT": "Documento de registro en la oficina tributaria",
								"AU": "Escritura fiduciaria",
								"BE": "Número de IVA habilitado para operaciones transfronterizas (VIES).",
								"DE": "Documento de registro en la oficina tributaria",
								"FR": "Número de IVA habilitado para operaciones transfronterizas (VIES).",
								"IT": "Número de IVA habilitado para operaciones transfronterizas (VIES).",
								"NL": "Número de IVA habilitado para operaciones transfronterizas (VIES).",
								"NO": "Inscripción en agencia tributaria",
								"US": "EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Aceptamos los siguientes documentos como documentos empresariales: Extracto del registro mercantil/Licencia de empresario individual",
								"AU": "Si tu ABN está asociado a un fideicomiso, facilita una copia del documento fiduciario que incluya la cláusula del fideicomiso. Ten en cuenta que este paso es obligatorio en el caso de fideicomisos.",
								"BE": "Verifica que tu número de IVA permite realizar operaciones transfronterizas. Esto es necesario aunque solo comercies en tu país, ya que Klarna es una entidad extranjera. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Puedes contactar con la oficina tributaria local para solicitar la activación gratuita del VIES de tu número de IVA.",
								"CZ": "Aceptamos los siguientes documentos como documentos empresariales: Certificado de inscripción en el registro público o extracto del registro mercantil como empresario individual.",
								"DE": "Aceptamos los siguientes documentos como documentos empresariales: Extracto del registro mercantil/Licencia de empresario individual",
								"ES": "Aceptamos los siguientes documentos como documentos de empresas: Escrituras de constitución para empresas y asociaciones; y Certificado de situación censal o Modelo 036/ Modelo 037 para autónomos",
								"FI": "Aceptamos los siguientes documentos: Escrituras de constitución para empresas y asociaciones; y Certificado de situación censal o Modelo 036/ Modelo 037 para autónomos",
								"FR": "Verifica que tu número de IVA permite realizar operaciones transfronterizas. Esto es necesario aunque solo comercies en tu país, ya que Klarna es una entidad extranjera. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Puedes contactar con la oficina tributaria local para solicitar la activación gratuita del VIES de tu número de IVA.",
								"GR": "Aceptamos los siguientes documentos como documentos empresariales: Documento de registro en la oficina tributaria/inicio de actividad empresarial/registro mercantil emitido por el servicio GEMI competente (Unión Central de Cámaras)",
								"IT": "Puedes contactar con la autoridad fiscal (Agenzia delle Entrate) para solicitar la activación gratuita del VIES de tu número de IVA. Esto será necesario aunque solo comercies en Italia, ya que Klarna es una entidad extranjera.",
								"NL": "Verifica que tu número de IVA permite realizar operaciones transfronterizas. Esto es necesario aunque solo comercies en tu país, ya que Klarna es una entidad extranjera. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Puedes contactar con la oficina tributaria local para solicitar la activación gratuita del VIES de tu número de IVA.",
								"NO": "Aceptamos los siguientes documentos como documentos empresariales: Documentación de la empresa",
								"PL": "Aceptamos los siguientes documentos como documentos empresariales: Certificado de inscripción en el registro mercantil CEIDG, extracto del registro judicial nacional (KRS)",
								"PT": "Aceptamos los siguientes documentos como documentos empresariales:  Certidão Permanente (Obligatorio), Certificado de registro. Para empresarios individuales, Declaración de inicio de actividad (Declaração de Início de Atividade).",
								"US": "Esta es la carta recibida del IRS donde se te asigna una EIN (letra IRS CP575 EIN). Si tu empresa es una sociedad individual y utilizas el número de la SS, facilita una copia de tu tarjeta de la SS en su lugar."
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Documento de identificación certificado"
							},
							"subtitle": {
								"default": "Aceptamos los siguientes documentos: documento de identidad, pasaporte, permiso de conducir. Estos documentos deben cumplir los siguientes criterios:"
							},
							"list": [
								{
									"text": "Certificados por un agente autorizado (p. ej., un notario, un abogado y/o un contable certificado)."
								},
								{
									"text": "Firmados y sellados. El sello debe mostrar detalles visibles y verificables del certificador, como el nombre completo, la dirección y, si procede, el número de registro."
								},
								{
									"text": "Fechados: fecha de certificación no superior a 6 meses."
								},
								{
									"text": "Certificados como una copia fiel del original al indicar claramente que el documento original se ha cotejado."
								}
							]
						}
					},
					"modal": {
						"title": "¿Por qué necesitamos estos documentos?",
						"close": "Cerrar",
						"content": [
							{
								"title": "Descripción del proceso",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Requisitos de los archivos",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "¿Cómo debes escanear los documentos?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Error al cargar",
						"too_large_file": "El archivo es demasiado grande <strong>(máx. {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Solo puedes cargar {number} archivos.",
						"invalid_file_format": "Formato de archivo no válido. Los únicos tipos de archivo aceptados son {acceptedFileFormats}",
						"duplicate_file_name": "Nombre de archivo duplicado. Todos los archivos cargados deben tener nombres únicos.",
						"try_again": "Prueba de nuevo o <u>elige otro archivo</u>"
					},
					"buttons": {
						"modal": "¿Por qué necesitamos estos documentos?",
						"next": "Siguiente",
						"back": "Atrás",
						"submit": "Enviar documentos"
					}
				},
				"document_upload_success": {
					"title": "Carga completada.",
					"message": "¡Gracias! Tus documentos se han cargado correctamente."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "¿Podrías indicar, por favor, tu número de inscripción en el registro?",
							"AT": "¿Podrías indicar, por favor, tu número de inscripción en el registro?",
							"CA": "¿Podrías indicar tu BN federal?",
							"GR": "¿Podrías introducir tu número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)?",
							"NZ": "¿Podrías indicar tu número de empresa?"
						},
						"managed": {
							"default": "¿Podrías indicar, por favor, tu NIF?",
							"AT": "¿Podrías indicar, por favor, tu NIF?",
							"CA": "¿Podrías indicar tu BN federal?",
							"GR": "¿Podrías introducir el número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.) de la empresa?",
							"NZ": "¿Podrías indicar, por favor, el número registro del negocio?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
							"AT": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
							"CA": "Necesitamos tu número de empresa (BN) asignado por la CRA (Canada Revenue Agency) para verificar tus datos empresariales.",
							"GR": "Necesitamos tu número de inscripción en el registro mercantil para verificar los datos del negocio.",
							"NZ": "Necesitamos tu número de registro de tu empresa para verificar los datos de tu negocio."
						},
						"managed": {
							"default": "Necesitamos el NIF para verificar los datos de la empresa.",
							"AT": "Necesitamos el NIF para verificar los datos de la empresa.",
							"CA": "Necesitamos tu número de empresa (BN) asignado por la CRA (Canada Revenue Agency) para verificar tus datos empresariales.",
							"GR": "Necesitamos el número de inscripción en el registro mercantil para verificar los datos del negocio.",
							"NZ": "Necesitamos el número de negocio de la empresa para verificar los datos del negocio."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Recuerda que Klarna actualmente no puede ofrecer sus servicios de pagos a empresarios individuales canadienses. Esta solicitud será rechazada."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Número de inscripción en el registro",
								"AT": "Número de inscripción en el registro",
								"CA": "Número de empresa",
								"GR": "Número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)",
								"NZ": "Número de empresa"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "¿Cuál es tu clasificación fiscal?",
						"managed": "¿Podrías indicarnos la clasificación fiscal de tu empresa?"
					},
					"subtitle": {
						"unmanaged": "Te pediremos datos diferentes según la situación jurídica de tu empresa.",
						"managed": "Te pediremos datos diferentes según la situación jurídica de tu empresa."
					},
					"info": {
						"unmanaged": "Encontrarás el EIN (Número de Identificación de Empresa) de tu negocio en las declaraciones fiscales, los informes de crédito e impresos de nóminas, licencias y permisos.",
						"managed": "Encontrarás el EIN (Número de Identificación de Empresa) de la empresa en las declaraciones fiscales, los informes de crédito e impresos de nóminas, licencias y permisos."
					},
					"fields": {
						"registration_number": {
							"label": "Número de Identificación de Empresa",
							"errors": {
								"general": "Indica un Número de Identificación de Empresa válido",
								"invalid": "El número de identificación de empresa debe tener 9 dígitos y un \"-\" después de los dos primeros. Por ej.: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Clasificación fiscal federal",
								"managed": "Tipo de empresa"
							},
							"errors": {
								"is_one_of": "Elige uno de los tipos de empresa enumerados"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "¿Podrías indicar, por favor, tu número de IVA?",
							"AU": "¿Podrías indicar, por favor, tu ABN?",
							"ES": "¿Cuál es tu número de identificación fiscal?",
							"NZ": "¿Podrías indicar tu número de GST?"
						},
						"managed": {
							"default": "¿Podrías indicar, por favor, tu NIF?",
							"AU": "¿Podrías indicar, por favor, el ABN?",
							"ES": "¿Cuál es tu número de identificación fiscal?",
							"NZ": "¿Podrías indicar el número de GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Tu número de IVA nos facilita poder verificar tus datos corporativos.",
							"AU": "Tu número ABN nos facilita poder verificar tus datos corporativos.",
							"NZ": "Tu número de GST nos facilita poder verificar tus datos corporativos.",
							"ES": "Con un NIF, NIE o DNI podremos verificar más fácilmente tus datos corporativos."
						},
						"managed": {
							"default": "Utilizamos tu NIF para verificar los datos corporativos.",
							"AU": "Utilizamos el ABN para verificar los datos corporativos.",
							"NZ": "Utilizamos el número de GST para verificar los datos corporativos.",
							"ES": "Con un NIF, NIE o DNI podremos verificar más fácilmente los datos corporativos."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Número de IVA",
								"AU": "ABN",
								"NZ": "Número de GST",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "¿Qué tipo de negocio tienes?",
						"managed": "¿Cuál es el tipo de negocio de esta empresa?"
					},
					"subtitle": {
						"unmanaged": "Tenemos la obligación de preguntar por algunos datos específicos en función de tu tipo de empresa.",
						"managed": "Tenemos la obligación de preguntar por algunos datos específicos en función del tipo de empresa."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Tipo de entidad jurídica",
							"errors": {
								"is_one_of": "Elige uno de los tipos de empresa enumerados"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "¿Es tu negocio una empresa registrada?",
							"AU": "¿Tiene tu negocio un ACN?",
							"ES": "¿Tu empresa está en el Registro Mercantil?"
						},
						"managed": {
							"default": "¿Está vuestra empresa inscrita en el Registro Mercantil?",
							"AU": "¿Tiene este negocio un ACN?",
							"ES": "¿Tu empresa está en el Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
							"AT": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
							"AU": "Si tienes un ACN indícalo. De lo contrario, selecciona “no” y continúa.",
							"ES": "Responde “Sí”, si eres una SL, SA, SCP, etc. Responde “No” si eres autónomo, freelancer, etc.",
							"GB": "Necesitamos el número de organización de tu empresa para verificar los datos de tu negocio.",
							"GR": "Necesitamos tu número de inscripción en el registro mercantil para verificar los datos del negocio."
						},
						"managed": {
							"default": "Necesitamos el NIF para verificar los datos de la empresa.",
							"AT": "Necesitamos el NIF para verificar los datos de la empresa.",
							"AU": "Si esta empresa tiene un ACN indícalo. De lo contrario, selecciona “no” y continúa.",
							"ES": "Responde “Sí”, si eres una SL, SA, SCP, etc. Responde “No” si eres autónomo, freelancer, etc.",
							"GB": "Necesitamos el número de organización de la empresa para verificar los datos del negocio de la empresa.",
							"GR": "Necesitamos el número de inscripción en el registro mercantil de la empresa para verificar los datos del negocio."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Indica tu número de inscripción en el registro",
							"AT": "Indica tu número de inscripción en el registro",
							"AU": "Indica tu ACN",
							"ES": "Introduce el NIF/NIE/DNI de tu empresa",
							"GB": "Indica tu número de organización",
							"GR": "Introduce tu número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Indica tu NIF",
							"AT": "Indica tu NIF",
							"AU": "Indica una el ACN",
							"ES": "Introduce el NIF/NIE/DNI de tu empresa",
							"GB": "Indica el número de la organización",
							"GR": "Introduce el número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Número de inscripción en el registro",
								"AT": "Número de inscripción en el registro",
								"AU": "Número de Sociedad Australiana (Australian Company Number, ACN)",
								"ES": "NIF/NIE/DNI de la empresa",
								"GB": "Número de organización",
								"GR": "Número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"mid-selector": {
					"title": "Selecciona una tienda",
					"subtitle": "Este e-mail está asociado a varias tiendas. Selecciona una tienda para continuar.",
					"mid-selector": "ID de comercio / Nombre de tienda",
					"buttons": {
						"next": "Continuar"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "¿Es tu negocio una empresa registrada?",
						"managed": "¿Está vuestra empresa inscrita en el Registro Mercantil?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
							"AT": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio."
						},
						"managed": {
							"default": "Necesitamos el NIF para verificar los datos de la empresa.",
							"AT": "Necesitamos el NIF para verificar los datos de la empresa."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Indica tu número de inscripción en el registro",
							"AT": "Indica tu número de inscripción en el registro"
						},
						"managed": {
							"default": "Indica tu NIF",
							"AT": "Indica tu NIF"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Número de inscripción en el registro",
								"AT": "Número de inscripción en el registro"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "¿Está registrada tu empresa a efectos de IVA?",
							"ES": "¿Tu empresa tiene un NIF/NIE/DNI?",
							"NZ": "¿Está registrada tu empresa a efectos de GST?"
						},
						"managed": {
							"default": "¿Está registrada esta empresa a efectos de IVA?",
							"ES": "¿Tu empresa tiene un NIF/NIE/DNI?",
							"NZ": "¿Está registrada esta empresa a efectos de GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Si tienes un número de IVA podremos verificar más fácilmente tus datos corporativos.",
							"ES": "Si tu empresa tiene un NIF, NIE o DNI podremos verificar más fácilmente tus datos corporativos.",
							"NZ": "Si tienes un número de GST podremos verificar más fácilmente tus datos corporativos."
						},
						"managed": {
							"default": "Utilizamos tu NIF para verificar los datos corporativos.",
							"ES": "Si tu empresa tiene un NIF, NIE o DNI podremos verificar más fácilmente tus datos corporativos.",
							"NZ": "Utilizamos el número de GST para verificar los datos corporativos."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Indica tu número de IVA",
							"ES": "Introduce el NIF/NIE/DNI de tu empresa",
							"NZ": "Indica tu número de GST"
						},
						"managed": {
							"default": "Indica tu NIF",
							"ES": "Introduce el NIF/NIE/DNI de tu empresa",
							"NZ": "Indica tu número de GST"
						}
					},
					"vat_id": {
						"label": {
							"default": "NIF",
							"ES": "NIF/NIE/DNI de la empresa",
							"NZ": "Número de GST"
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "¿Está registrada tu empresa a efectos de IVA?",
						"managed": "¿Está registrada esta empresa a efectos de IVA?"
					},
					"subtitle": {
						"unmanaged": "Si tienes un número de IVA podremos verificar más fácilmente tus datos corporativos.",
						"managed": "Utilizamos tu NIF para verificar los datos corporativos."
					},
					"form_title": {
						"unmanaged": "Indica tu número de IVA",
						"managed": "Indica tu NIF"
					},
					"vat_id": {
						"label": {
							"default": "Número de IVA",
							"NZ": "Número de GST"
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "¿Cuál es la dirección de tu empresa?",
						"managed": "¿Cuál es el domicilio profesional de la empresa?"
					},
					"subtitle": {
						"unmanaged": "Necesitamos saber dónde está ubicada tu empresa.",
						"managed": "Necesitamos saber dónde está ubicada la empresa."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					},
					"fields": {
						"partnership_name": {
							"label": "Nombre de asociación",
							"errors": {
								"general": "Indica un nombre de asociación"
							}
						},
						"street": {
							"label": "Calle",
							"errors": {
								"general": "Indica una calle válida"
							}
						},
						"postal_code": {
							"label": "Código postal",
							"errors": {
								"general": "Indica un código postal válido"
							}
						},
						"city": {
							"label": "Ciudad",
							"errors": {
								"general": "Indica una ciudad válida"
							}
						},
						"country": {
							"label": "País",
							"errors": {
								"general": "Indica un país válido"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "¿Quién ostenta la propiedad de la empresa?",
						"GB": "¿Quién dirige la empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Es un requisito legal. En virtud de la directiva contra el blanqueo de capitales de la UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						],
						"AU": [
							{
								"text": "Como entidad financiera, tenemos la obligación legal de recopilar esta información."
							}
						]
					},
					"infobox": "Indica la información personal y la dirección particular de todos los socios y mandantes que ejercen el control de la administración de tu empresa.",
					"buttons": {
						"add_person": "+ Añadir persona",
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"payouts_summary": {
					"title": "Cuentas bancarias",
					"default_bank_accounts": {
						"no_elements": "No se dispone de cuenta bancaria predeterminada"
					},
					"additional_bank_accounts": {
						"no_elements": "No indicaste ninguna cuenta bancaria adicional"
					}
				},
				"pre_assessment_company_details": {
					"title": "Rellena más datos de oportunidades.",
					"subtitle": "Indícanos el porcentaje de volumen de tarjetas y los datos corporativos de este comerciante. Indica también si la empresa opera desde otro mercado, distinto del país donde la empresa está registrada, ya que es necesario para la evaluación de riesgos.",
					"fields": {
						"volume_by_card": {
							"label": "Porcentaje de volumen de tarjetas respecto al volumen total (%)",
							"errors": {
								"invalid": "El volumen de tarjetas debería ser un número del 0 al 100",
								"invalid_hint": "Indica el porcentaje del volumen de transacciones con tarjeta respecto al volumen total de Klarna para esta oportunidad. Indica 0 % si tu oportunidad no tiene ningún pago con tarjeta"
							}
						},
						"average_order_value": {
							"label": "Valor medio de pedido (en SEK)",
							"tooltip": "Debe ser un importe positivo en SEK",
							"errors": {
								"invalid": "Debe ser un importe positivo en SEK"
							}
						},
						"registration_country": {
							"label": "País donde la empresa está registrada",
							"errors": {
								"required": "El país de registro es obligatorio"
							}
						},
						"operating_country": {
							"label": "País operativo",
							"errors": {
								"required": "El país operativo es obligatorio"
							}
						},
						"registration_number": {
							"label": {
								"default": "Número de inscripción en el registro (Requerido a las empresas registradas)",
								"AU": "ACN (Requerido a las empresas registradas)",
								"ES": "NIF de la empresa/NIE/DNI (Requerido a las empresas registradas)",
								"GR": "Número de inscripción en el registro mercantil (Γ.Ε.ΜΗ.) (Requerido a las empresas registradas)",
								"NZ": "Número de empresa (Requerido a las empresas registradas)",
								"US": "TIN/EIN (Requerido a las empresas registradas)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Indica un ACN o un ABN",
								"invalid": "El ABN debe tener 11 dígitos."
							}
						},
						"registration_authority": {
							"label": "Autoridad responsable del registro",
							"errors": {
								"required": "Selecciona tu autoridad de registro"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "E-mail del representante comercial",
							"errors": {
								"invalid": "Indica un e-mail válido"
							}
						},
						"store_url": {
							"label": "URL de la tienda",
							"errors": {
								"required": "La URL de la tienda es obligatoria",
								"invalid": "Indica una URL de sitio web válida"
							}
						},
						"goods_category": {
							"label": "Categoría principal de mercancías vendidas",
							"errors": {
								"invalid": "Debes seleccionar una de las opciones"
							}
						},
						"is_managed": {
							"label": "¿Gestionado después de su activación?"
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"pre_assessment_products": {
					"title": "Enumera todos los productos",
					"subtitle": "Para fines de evaluación de riesgos son obligatorios todos los productos por país de venta",
					"select": {
						"label": "Buscar producto"
					},
					"selected": {
						"label": "Productos seleccionados:"
					},
					"clear": "Borrar todo",
					"errors": {
						"invalid": "Debes seleccionar al menos un producto por país"
					},
					"channels": {
						"ONLINE": "En línea",
						"IN_STORE": "En tienda física",
						"TELESALES": "Televenta",
						"SELLER_APP": "App del vendedor"
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"wrong_prefill_data": {
					"title": "Los datos aportados no son válidos",
					"subtitle": "Los datos de autocompletar indicados por el personal ventas no son válidos o son incompatibles.",
					"details": "Datos: ",
					"fields": {
						"goodsCategory": "Categoría de mercancías",
						"paymentInterval": "Intervalo de pago",
						"paymentDelay": "Retraso del pago",
						"registrationCountry": "País donde la empresa está registrada",
						"storeUrl": "URL de la tienda",
						"mainSellingCountry": "Principal país de venta",
						"products": "Productos",
						"products_item": "Producto {index}",
						"products_item_yearlyAcquiredVolume": "Volumen adquirido anualmente del producto {index}",
						"products_item_sellingCountry": "País de venta del producto {index}",
						"products_item_productName": "Nombre del producto {index}",
						"products_item_channels": "Canales del producto {index}",
						"products_item_channels_item": "Canal del producto {index}"
					},
					"error_types": {
						"fallback": "no es válido",
						"any": {
							"required": "es obligatorio y no se indicó"
						}
					}
				},
				"selling_countries": {
					"title": "Enumera todos los países de venta",
					"subtitle": "La lista completa de los países es obligatoria para evaluación de riesgos",
					"select": {
						"label": "Buscar país"
					},
					"selected": {
						"label": "Países seleccionados:"
					},
					"fields": {
						"selling_countries": {
							"label": "Seleccionar país",
							"errors": {
								"invalid": "Debes seleccionar al menos un país"
							}
						}
					},
					"clear": "Borrar todo",
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"main_selling_country": {
					"title": "¿Cuál es el principal mercado de Klarna para el comerciante?",
					"subtitle": "Selecciona el mercado para el que se espera el mayor volumen de Klarna",
					"errors": {
						"invalid": "Es necesario seleccionar un país"
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"fca_number": {
					"title": "Indica el número FCA",
					"subtitle": "La ley nos obliga a verificar la licencia del agente de crédito.",
					"fields": {
						"fca_number": {
							"label": "Número FCA",
							"errors": {
								"general": "Indica un número FCA válido"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"sole_trader": {
					"title": "¿Quién ostenta la propiedad de la empresa?",
					"subtitle": {
						"default": [
							{
								"text": "Es un requisito legal. En virtud de la directiva contra el blanqueo de capitales de la UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						]
					},
					"infobox": {
						"unmanaged": "Indica tu información personal y tu dirección particular.",
						"managed": "Indica la información del propietario y su dirección particular."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "La persona que presenta la solicitud es el propio empresario individual",
							"error": "Solo puedes seguir adelante si estás presentando esta solicitud en tu propio nombre como empresario individual."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "¿Llevas a cabo tu actividad en un domicilio diferente?",
								"managed": "¿Esta empresa lleva a cabo su actividad en un domicilio diferente?"
							},
							"subtitle": {
								"unmanaged": "Elige Sí únicamente si llevas a cabo tu actividad en una dirección distinta de tu domicilio particular.",
								"managed": "Elige Sí únicamente si esta empresa lleva a cabo su actividad en una dirección distinta del domicilio particular del empresario individual."
							}
						},
						"title": "Indica un domicilio profesional",
						"fields": {
							"street": {
								"label": "Calle",
								"errors": {
									"general": "Indica una calle válida"
								}
							},
							"postal_code": {
								"label": "Código postal",
								"errors": {
									"general": "Indica un código postal válido"
								}
							},
							"city": {
								"label": "Ciudad",
								"errors": {
									"general": "Indica una ciudad válida"
								}
							},
							"country": {
								"label": "País",
								"errors": {
									"general": "Indica un país válido"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "¿Podrías confirmar dos cosas más?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Eres un empresario individual",
							"label": "La persona que presenta la solicitud es el propio empresario individual"
						},
						"are_you_the_only_with_financial_control": {
							"title": "El control financiero solo depende de ti",
							"label": "El titular es la única persona que posee el control financiero de tus cuentas bancarias comerciales"
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					},
					"robot_message": "Debemos comprobar un par de detalles más"
				},
				"underwriting_info": {
					"title": "Especifica el volumen y el retraso del pago de la oportunidad",
					"subtitle": "Enumera el volumen general anual de Klarna que cabe esperar para esta oportunidad en todos los mercados y el retraso del pago. Si el retraso del pago varía en cada país utiliza el dato del país seleccionado como principal país de venta.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Volumen total anual del mercado (en SEK)",
							"errors": {
								"invalid": "El volumen total anual del mercado debe ser una cantidad positiva en SEK",
								"too_long": "El volumen total anual del mercado no puede tener más de 16 dígitos"
							}
						},
						"payment_delay": {
							"label": "Retraso del pago",
							"errors": {
								"general": "Indica un valor de retraso del pago",
								"invalid": "El retraso del pago debe ser un número de {min} a {max}"
							}
						},
						"payment_interval": {
							"label": "Intervalo de pago",
							"errors": {
								"invalid": "Debes seleccionar una de las opciones"
							}
						},
						"volume_by_card": {
							"label": "Porcentaje de pago (%)",
							"errors": {
								"invalid": "El porcentaje de pago debe ser un número entre 0 y 100",
								"invalid_hint": "Indica el porcentaje del volumen de transacciones con tarjeta respecto al volumen total de Klarna para esta oportunidad. Indica 0 % si tu oportunidad no tiene ningún pago con tarjeta"
							}
						},
						"average_order_value": {
							"label": "Valor medio de pedido (en SEK)"
						}
					},
					"buttons": {
						"back": "Atrás",
						"next": "Siguiente"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Indica los datos de tu tienda"
						},
						"managed": "¿Cuáles son los datos de la tienda?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Utilizaremos esta información para configurar la cuenta de tu tienda.",
							"default": "Utilizaremos los datos facilitados como información de contacto principal y para echar un vistazo a tu tienda."
						},
						"managed": "Utilizaremos los datos facilitados como información de contacto principal para los consumidores y para echar un vistazo a la tienda."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Nombre de la marca / DBA",
								"MX": "Nombre de la marca / DBA",
								"US": "Nombre de la marca / DBA",
								"default": "Nombre de la tienda"
							},
							"errors": {
								"required": "El nombre de la tienda es obligatorio",
								"required_us": "Nombre de la marca / DBA es obligatorio",
								"invalid": "Introduce al menos 2 caracteres en el nombre de la tienda",
								"invalid_us": "Introduce al menos 2 caracteres en el nombre de la marca/DBA",
								"invalid_characters": "El nombre de la tienda no puede contener estos caracteres: < >",
								"invalid_characters_us": "El nombre de la marca/DBA no puede contener estos caracteres: < >"
							}
						},
						"website": {
							"label": "Sitio web de tienda en línea",
							"errors": {
								"required": "El sitio web es obligatorio",
								"invalid": "Indica una URL de sitio web válida"
							}
						},
						"goods_category": {
							"label": "Categoría principal de mercancías vendidas",
							"errors": {
								"required": "La categoría de mercancías es obligatoria"
							}
						},
						"email": {
							"label": "Correo electrónico de ayuda para el cliente",
							"errors": {
								"required": "El e-mail de atención al cliente es obligatorio",
								"invalid": "Indica un e-mail válido"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Cambiar productos"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "¿Cuál es el domicilio social de tu empresa?",
						"managed": "¿Cuál es el domicilio profesional oficial de la empresa?"
					},
					"subtitle": {
						"unmanaged": "Necesitamos la dirección donde la empresa tiene su domicilio social.",
						"managed": "Necesitamos el domicilio profesional en el que está registrada la empresa."
					},
					"question": {
						"title": {
							"unmanaged": "¿Llevas a cabo tu actividad en un domicilio diferente?",
							"managed": "¿Esta empresa lleva a cabo su actividad en un domicilio diferente?"
						},
						"subtitle": {
							"unmanaged": "Elige Sí únicamente si llevas a cabo tu actividad en una dirección distinta del domicilio profesional oficial.",
							"managed": "Elige Sí únicamente si esta empresa lleva a cabo su actividad en una dirección distinta del domicilio profesional oficial."
						}
					},
					"toggle": {
						"title": "Añade la dirección del domicilio profesional principal"
					},
					"fields": {
						"company_name": {
							"label": "Denominación legal de la empresa",
							"errors": {
								"general": "Indica un nombre de empresa"
							}
						},
						"street": {
							"label": "Dirección",
							"errors": {
								"general": "Indica una calle"
							}
						},
						"postal_code": {
							"label": "Código postal",
							"errors": {
								"general": "Indica un código postal"
							}
						},
						"city": {
							"label": "Ciudad",
							"errors": {
								"general": "Indica una ciudad"
							}
						},
						"country": {
							"label": "País",
							"errors": {
								"general": "Indica un país"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					},
					"messages": {
						"lookup": "¿Esta es tu empresa? Repasa lo siguiente y confirma si es correcto."
					}
				},
				"uk_sole_trader": {
					"title": "¿Quién ostenta la propiedad de esta empresa?",
					"subtitle": {
						"unmanaged": "Te dispones a formalizar un contrato con Klarna. Por ello, necesitamos recopilar tus datos personales.",
						"managed": "La ley nos obliga a obtener y verificar los datos personales del titular."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "¿Llevas a cabo tu actividad en un domicilio diferente?",
								"managed": "¿Esta empresa lleva a cabo su actividad en un domicilio diferente?"
							},
							"subtitle": {
								"unmanaged": "Elige Sí únicamente si llevas a cabo tu actividad en una dirección distinta de tu domicilio particular.",
								"managed": "Elige Sí únicamente si esta empresa lleva a cabo su actividad en una dirección distinta del domicilio particular del empresario individual."
							}
						},
						"title": "Indica un domicilio profesional",
						"fields": {
							"street": {
								"label": "Calle",
								"errors": {
									"general": "Indica una calle válida"
								}
							},
							"postal_code": {
								"label": "Código postal",
								"errors": {
									"general": "Indica un código postal válido"
								}
							},
							"city": {
								"label": "Ciudad",
								"errors": {
									"general": "Indica una ciudad válida"
								}
							},
							"country": {
								"label": "País",
								"errors": {
									"general": "Indica un país válido"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "¿Quién ostenta la propiedad de la empresa?",
					"subtitle": {
						"default": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
					},
					"infobox": {
						"unmanaged": "Indica tu información personal y tu dirección particular.",
						"managed": "Indica la información del propietario y su dirección particular."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "¿Llevas a cabo tu actividad en un domicilio diferente?",
								"managed": "¿Esta empresa lleva a cabo su actividad en un domicilio diferente?"
							},
							"subtitle": {
								"unmanaged": "Elige Sí únicamente si llevas a cabo tu actividad en una dirección distinta de tu domicilio particular.",
								"managed": "Elige Sí únicamente si esta empresa lleva a cabo su actividad en una dirección distinta del domicilio particular del empresario individual."
							}
						},
						"title": "Indica un domicilio profesional",
						"fields": {
							"street": {
								"label": "Calle",
								"errors": {
									"general": "Indica una calle válida"
								}
							},
							"postal_code": {
								"label": "Código postal",
								"errors": {
									"general": "Indica un código postal válido"
								}
							},
							"city": {
								"label": "Ciudad",
								"errors": {
									"general": "Indica una ciudad válida"
								}
							},
							"country": {
								"label": "País",
								"errors": {
									"general": "Indica un país válido"
								}
							},
							"region": {
								"label": "Estado",
								"errors": {
									"general": "Indica un estado"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "¿Alguna persona posee más del 25 % de la empresa?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
							}
						],
						"default": [
							{
								"text": "Necesitamos conocer a las personas que poseen más del 25 % de las acciones o los derechos de voto de la empresa o que ejercen un control similar. La directiva de la UE contra el blanqueo de capitales ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") nos obliga a recopilar esta información."
							}
						]
					},
					"infobox": {
						"default": "Indica la información personal y la dirección particular de cada una de estas personas.",
						"AU": "Indica la información personal y la dirección particular de cada una de estas personas. Deben ser personas físicas en el caso de empresas con estructuras de propiedad complejas."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás",
						"add_person": "+ Añadir persona"
					},
					"messages": {
						"lookup": "¿Estas personas poseen más del 25 % de tu empresa? Repasa lo siguiente y confirma si es correcto."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "¿Cuál es la dirección de tu empresa?",
						"managed": "¿Cuál es el domicilio profesional oficial de la empresa?"
					},
					"subtitle": {
						"unmanaged": "Es la dirección donde tu empresa está registrada legalmente y la que consta en tus facturas de cliente Klarna.",
						"managed": "Necesitamos el domicilio profesional en el que está registrada la empresa."
					},
					"question": {
						"title": {
							"unmanaged": "¿Llevas a cabo tu actividad en un domicilio diferente?",
							"managed": "¿Esta empresa lleva a cabo su actividad en un domicilio diferente?"
						},
						"subtitle": {
							"unmanaged": "Elige Sí únicamente si llevas a cabo tu actividad en una dirección distinta del domicilio profesional oficial.",
							"managed": "Elige Sí únicamente si esta empresa lleva a cabo su actividad en una dirección distinta del domicilio profesional oficial."
						}
					},
					"toggle": {
						"title": "Añade la dirección del domicilio profesional principal"
					},
					"fields": {
						"company_name": {
							"label": "El nombre registrado de la empresa",
							"errors": {
								"general": "Indica un nombre de empresa"
							}
						},
						"street": {
							"label": "Dirección",
							"errors": {
								"general": "Indica una calle"
							}
						},
						"postal_code": {
							"label": "Código postal",
							"errors": {
								"general": "Indica un código postal"
							}
						},
						"city": {
							"label": "Ciudad",
							"errors": {
								"general": "Indica una ciudad"
							}
						},
						"country": {
							"label": "País",
							"errors": {
								"general": "Indica un país"
							}
						},
						"state_of_incorporation": {
							"label": "Estado de constitución",
							"errors": {
								"general": "Indica un estado de constitución de la empresa"
							}
						},
						"state": {
							"label": "Estado",
							"errors": {
								"general": "Indica un estado"
							}
						},
						"region": {
							"label": "Región",
							"errors": {
								"puerto_rico": "Puerto Rico no está permitido"
							}
						}
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"select_products": {
					"title": "Nuestros servicios",
					"title_kco_hidden": "Métodos de pago que incrementan las ventas.",
					"subtitle": "Elige los servicios que sean de tu interés.",
					"subtitle_kco_hidden": "Activa poder adquisitivo para los clientes. Ofrece más opciones de pago para que puedan decidir cuándo y cómo pagar.",
					"platform_alert": null,
					"buttons": {
						"next": "Siguiente"
					}
				},
				"signup_products": {
					"title_line_1": "Elige tus productos Klarna.",
					"title_kco_hidden_line_1": "Métodos de pago que",
					"title_kco_hidden_line_2": "incrementan las ventas.",
					"subtitle": "Estos son los métodos de pago que podrás ofrecer a tus clientes.",
					"subtitle_kco_hidden": "Activa poder adquisitivo para los clientes. Ofrece más opciones de pago para que puedan decidir cuándo y cómo pagar.",
					"info_block": "Mostrar los productos disponibles para",
					"special_offer": "Oferta especial: {percentageFee} % + {fixedFee} por transacción. Caduca el {validUntil}.",
					"buttons": {
						"contact_sales": "Contactar con el servicio de ventas",
						"next": "Crear cuenta",
						"back": "Atrás"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Atrás",
						"next": "Siguiente"
					}
				},
				"business_concepts": {
					"title": "Selecciona los conceptos comerciales aplicables.",
					"subtitle": "Selecciona sólo los que sean aplicables. Pueden ser varios.",
					"errors": {
						"select_at_least_one": "Selecciona al menos un concepto comercial."
					},
					"buttons": {
						"next": "Siguiente",
						"back": "Atrás"
					}
				},
				"confirm_copy": {
					"title": "Confirmar copia",
					"disclaimer": "Toda la información incluida en el ID de comerciante actual se reemplazará con los datos de",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "No copiar",
						"confirmCopy": "Copiar datos"
					}
				},
				"pre_assessment_summary": {
					"title": "Summary",
					"subtitle": "Revisa los datos atentamente antes de enviarlo para suscripción",
					"banner": {
						"mcc_deal": "Esta es una oferta MCC, sigue la práctica de escalado MCC / ECC"
					},
					"selling_countries": {
						"title": "Selecciona el mercado para el que se espera el mayor volumen.",
						"main_selling_country": "Principal país de venta"
					},
					"pre_assessment_products": {
						"title": "Productos"
					},
					"company_details": {
						"title": "Datos corporativos"
					},
					"fca_number": {
						"title": "Número FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Cuestionarios de exposición alta"
					},
					"mia_questionnaires": {
						"title": "Cuestionarios MIA"
					},
					"buttons": {
						"back": "Atrás",
						"edit": "Editar",
						"submit": "Enviar"
					}
				},
				"pre_assessment_overview": {
					"title": "Visión general previa a la evaluación",
					"subtitle_APPROVED": "Aquí tienes las condiciones aprobadas para esta oportunidad.",
					"subtitle_REJECTED": "Aquí tienes las condiciones denegadas para esta oportunidad.",
					"subtitle_UNRESOLVED": "Puedes cambiar la información enviada en caso de detectar algún error. Esto no activará un nuevo caso.",
					"status": {
						"APPROVED": "El caso ha sido aprobado",
						"REJECTED": "El caso ha sido denegado",
						"UNRESOLVED": "Esperando la decisión de suscripción...",
						"UNRESOLVED_TIMED_OUT": "El caso seguirá un proceso manual de suscripción. Ten en cuenta que esto puede requerir varios días.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Ver el caso en Merchant Review GUI",
						"STARTED": "El caso ha sido enviado para su revisión"
					},
					"buttons": {
						"change": "Cambiar",
						"new_case": "Nuevo caso"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "¡Hola!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Al ser una empresa regulada y supervisada por la Autoridad de Control Financiero de Suecia, Klarna tiene la obligación de prevenir el blanqueo de capitales, según lo establece en la UE la directiva UE 2015/849 (y posteriores enmiendas o legislación que la sustituya). Dada tu condición de comerciante, la directiva supone para ti que Klarna recopilará los datos de las personas que ejercen el control de tu empresa (titulares beneficiarios) como condición para que empieces a utilizar los servicios de Klarna. Los comerciantes vigentes deberán facilitar dichos datos periódicamente para asegurar que estén actualizados. Encontrarás más información sobre la directiva de la UE "
							},
							{
								"text": "aquí",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Siguiente"
					}
				},
				"recollection_confirmation": {
					"title": "Confirmación",
					"subtitle": "Revisa los datos atentamente antes de enviarlo para suscripción",
					"stakeholder": "Accionista {index}",
					"buttons": {
						"back": "Atrás",
						"submit": "Enviar"
					}
				},
				"recollection_overview": {
					"title": "¡Gracias!",
					"subtitle": "Aquí tienes una visión general de los datos que facilitaste.",
					"stakeholder": "Accionista {index}",
					"notice": "Tus datos se han enviado correctamente."
				},
				"volume_separation": {
					"title_line_1": "¿De qué tamaño es tu negocio en línea?",
					"subtitle": "Klarna dispone de las mejores soluciones para tu empresa, ya sea grande, mediana o pequeña.",
					"selector_title": "Ingresos anuales",
					"below": "Menos de {threshold}",
					"between": "Entre {belowThreshold} y {aboveThreshold}",
					"over": "Más de {threshold}",
					"buttons": {
						"back": "Atrás"
					}
				},
				"basic_info": {
					"title_line_1": "Impulsa tu negocio",
					"title_line_2": "con Klarna.",
					"subtitle": "Necesitamos cierta información básica para orientarte correctamente.",
					"fields": {
						"email": {
							"label": "E-mail comercial",
							"field_link": "¿No eres una empresa o autónomo?",
							"errors": {
								"required": "La dirección de e-mail es obligatoria",
								"invalid": "Indica una dirección de e-mail válida"
							}
						},
						"email_confirmation": {
							"label": "Confirmar el e-mail comercial",
							"tooltip": "Tu e-mail comercial será la principal vía de comunicación con Klarna. Asegúrate de que es el correcto",
							"errors": {
								"required": "La dirección e-mail de confirmación es obligatoria",
								"invalid": "Asegúrate de haber introducido el mismo e-mail las dos veces"
							}
						},
						"website": {
							"label": "URL de e-commerce",
							"errors": {
								"required": "La URL de e-commerce es obligatoria",
								"invalid": "Indica una URL válida"
							}
						},
						"country": {
							"label": "País donde la empresa está registrada",
							"errors": {
								"general": "Selecciona uno de los países disponibles"
							}
						}
					},
					"buttons": {
						"continue": "Continuar"
					}
				},
				"contact_details": {
					"title_line_1": "¡Contactemos a través del chat!",
					"subtitle": "Rellena este formulario y te contactaremos lo antes posible para proponerte soluciones personalizadas para tu negocio.",
					"fields": {
						"full_name": {
							"label": "Nombre completo",
							"errors": {
								"required": "El nombre completo es obligatorio"
							}
						},
						"phone": {
							"label": "Número de teléfono",
							"tooltip": "Debes incluir el código del país, por ej., +1 541 754 3010",
							"errors": {
								"required": "El número de teléfono es obligatorio",
								"invalid": "Número de teléfono no válido"
							}
						},
						"tell_us_more": {
							"label": "Cuéntanos algo más sobre tu empresa (opcional)"
						}
					},
					"buttons": {
						"back": "Atrás",
						"submit": "Enviar datos de contacto"
					}
				},
				"contact_received": {
					"title": "¡No tardaremos en contactar contigo!",
					"message_1": "Nuestro equipo comercial te localizará lo antes posible.",
					"message_2": "Nuestro equipo se pondrá en contacto lo antes posible. También hemos enviado una confirmación de los datos que has facilitado a "
				},
				"we_are_sorry": {
					"title": "Lo sentimos. No podemos aceptar su solicitud en este momento.",
					"message_1_unsupported_country": "Actualmente Klarna no es compatible con el país que has seleccionado:",
					"message_1_sensitive_goods": "Klarna no es compatible con la categoría de mercancías seleccionada:",
					"message_1_platform": "Klarna no es compatible con la plataforma de e-commerce seleccionada: ",
					"message_2": "Buscamos constantemente nuevas colaboraciones, por lo que nos pondremos en contacto en cuanto sea posible continuar con su solicitud en un futuro.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Aún puedes utilizar"
							},
							{
								"text": "el plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "de nuestro socio Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "¿Con qué plataforma trabajas?",
					"subtitle": "Elige una plataforma de e-commerce y nos encargaremos de la integración de tu empresa rápidamente.",
					"custom": "Integración propia",
					"other_platform": "Otras soluciones de integración",
					"platform_search": {
						"label": "Plataforma de e-commerce",
						"no_match": "No se han encontrado resultados para \"{input}\""
					},
					"buttons": {
						"back": "Atrás"
					}
				},
				"partner": {
					"title_line_1": "¿Con qué socio de servicios de pago te gustaría realizar la incorporación?",
					"subtitle": "Elige el socio de servicios de pago que mejor se adapte a tus necesidades."
				},
				"account_creation_loading": {
					"title": "Creando tu cuenta…",
					"message": "Configurando tu ID de empresa…"
				},
				"application_checking": {
					"title": "Comprobando tu solicitud…",
					"message": "Analizando los datos almacenados"
				},
				"application_review": {
					"title": "Se está revisando tu solicitud.",
					"title_approved": "¡Tu solicitud ha sido aprobada!",
					"message": "Al tratarse de un proceso manual, el tiempo de gestión puede variar, pero intentaremos que sea lo más rápido posible.",
					"email_info_1": "Te hemos enviado un e-mail con el asunto “{subject}”.",
					"email_info_2": "Sigue los pasos que se indica para iniciar sesión y seguir el estado de tu solicitud.",
					"email_info_2_approved": "Sigue los pasos que se indican para iniciar sesión e integrar Klarna en tu tienda de e-commerce.",
					"email_subject": "Bienvenido al Portal del comercio de Klarna",
					"resend_email": "Reenviar e-mail"
				},
				"user_already_exists": {
					"title": "Inicia sesión en el Portal del comercio para continuar.",
					"message_1": "Esta dirección de e-mail ya está asociada a una cuenta de Portal del comercio. Para cambiar los datos de tu cuenta vigente inicia sesión",
					"log_in": "Inicia sesión en el Portal del comercio",
					"forgot_password": "¿Olvidaste tu contraseña?"
				},
				"otherPlatform": {
					"info": "Ya tenemos compatibilidad para {platform}",
					"link": "Comienza el proceso de integración aquí",
					"title": "La integración puede ser directa. ¡Así de smoooth!",
					"info2": "¡Buenas noticias! Ya puedes integrar Klarna en tu comercio electrónico directamente desde <strong>{platform}</strong>.",
					"link2": "Accede a {platform} + Integración de Klarna"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Contacta directamente con tu equipo comercial",
							"SE": "Contacta directamente con tu equipo comercial en"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "¿Ofreces alguno de los siguientes productos o servicios?",
					"subtitle_2": "Klarna puede definir algunos artículos como restringidos en función del mercado, las leyes, el volumen de ventas, la tolerancia al riesgo, así como otras limitaciones que pueden permitirse y no deben procesarse sin el consentimiento de Klarna.",
					"titleV2": "Elige cuál de estas opciones se aplica a tu negocio.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Productos restringidos por razones de edad",
							"description_2": "Tabaco, cigarrillos electrónicos, vapeadores, productos de cannabis, alcohol, contenido para adultos"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Viajes, recorridos y eventos",
							"description_2": "Transporte, eventos, plataformas de entradas, hoteles o alojamiento, alquileres, agencias de viajes"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Armas con licencia",
							"description_2": "Munición, cuchillos de combate, equipamiento de caza, porras, espray de pimienta"
						},
						"MARKETPLACE": {
							"title_2": "Mercados entre pares",
							"description_2": "Servicios que permiten a terceras partes revender sus productos u ofrecer servicios a través de su plataforma en línea"
						},
						"PHARMACEUTICALS": {
							"title_2": "Sector farmacéutico y servicios médicos",
							"description_2": "Distribución de productos farmacéuticos con receta, procedimientos médicos incluidos de estética y tatuajes"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Afiliaciones, suscripciones y servicios",
							"description_2": "Suscripciones a bienes físicos, contenido digital, servicios de streaming, sitios de citas, etc."
						},
						"NONE": {
							"title_2": "Ofrezco otro tipo de producto/servicio"
						}
					},
					"link": "Más sobre los artículos restringidos",
					"buttons": {
						"next": "Siguiente",
						"continue": "Continuar"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Escribe tu código postal para rellenar automáticamente otros campos de tu dirección",
						"US": "Escribe tu código postal para rellenar automáticamente otros campos de tu dirección"
					},
					"label": {
						"default": "Código postal",
						"US": "Código postal"
					},
					"error": {
						"default": "Indica un código postal válido",
						"US": "Indica un código postal válido"
					}
				},
				"city": {
					"label": "Ciudad",
					"error": "Indica una ciudad"
				},
				"street": {
					"label": "Calle",
					"error": "Indica una calle",
					"tooltip": "Empieza a escribir para ver más sugerencias de calles",
					"no_suggestion_found": "No hay resultados para {input}"
				},
				"country": {
					"label": "País",
					"error": "Selecciona un país"
				},
				"region": {
					"label": "Estado/región (opcional)"
				},
				"state": {
					"label": "Estado",
					"error": "Indica un estado"
				}
			},
			"platforms": {
				"custom": "Integración de la API",
				"other": "No encuentro mi plataforma"
			},
			"buttons": {
				"back": "Atrás"
			},
			"products": {
				"not_available": "No disponible en {reason}",
				"not_available_country": "No disponible en este país",
				"not_available_platform": "No disponible en {platform}",
				"why_product": "Por qué elegir Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Sustituye tu proceso de pago con el servicio completo de pagos de Klarna."
					},
					"description_expanded": {
						"default": "Sustituye tu proceso de pago con el servicio completo de pagos de Klarna."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Pagar ahora"
							},
							"description": {
								"default": "Ofrecer pagos instantáneos con tarjeta o transferencia bancaria."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Paga en 30 días"
							},
							"description": {
								"default": "Ofrecer pago en 30 días. Sin intereses."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Financiación"
							},
							"description": {
								"default": "Ofrecer pago entre 6-36 meses.",
								"DE": "Ofrecer pago entre 6-24 meses.",
								"AT": "Ofrecer pago entre 6-24 meses."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Paga en 3 plazos"
							},
							"description": {
								"default": "Ofrecer 3 plazos sin intereses.",
								"GB": "Ofrecer 3 plazos sin intereses."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Paga en 4 plazos",
								"US": "Plazos",
								"AU": "Pagar en 4 plazos"
							},
							"description": {
								"default": "Ofrecer 4 plazos sin intereses.",
								"GB": "Ofrecer 4 plazos sin intereses."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Otras opciones de pago"
							},
							"description": {
								"default": "Tarjetas de crédito, débito y más"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "La mensajería en la web"
							}
						},
						"billing": {
							"name": {
								"default": "Facturación e identificación automática"
							}
						},
						"shipping": {
							"name": {
								"default": "Opciones de envío personalizadas"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Soporte posventa"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Método de pago"
					},
					"description": {
						"default": "Añade los métodos de pago de Klarna a tu proceso"
					},
					"description_expanded": {
						"default": "Ofrecer los métodos de pago de Klarna lleva a un incremento del 30 % en las conversiones, un 41 % en el valor medio del pedido y un 36 % en la frecuencia de compra."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Pagar ahora"
							},
							"description": {
								"default": "Ofrecer pagos instantáneos con tarjeta o transferencia bancaria."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Paga en 30 días"
							},
							"description": {
								"default": "Los clientes pagan 30 días después de la compra, sin intereses."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Financiación"
							},
							"description": {
								"default": "Los clientes pueden pagar en 6-36 meses.",
								"DE": "Los clientes pueden pagar en 6-24 meses",
								"AT": "Los clientes pueden pagar en 6-24 meses."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Paga en 3 plazos"
							},
							"description": {
								"default": "Ofrecer 3 plazos sin intereses.",
								"GB": "Ofrecer 3 plazos sin intereses."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Paga en 4 plazos",
								"US": "4 pagos",
								"CA": "4 plazos",
								"AU": "Pagar en 4 plazos"
							},
							"description": {
								"default": "Ofrecer 4 plazos sin intereses.",
								"GB": "Ofrecer 4 plazos sin intereses.",
								"US": "Los pedidos de 35 $ a 1000 $ se pueden dividir en 4 plazos sin intereses, con vencimiento cada 2 semanas.",
								"CA": "Los pedidos de 35 $ a 1000 $ se pueden dividir en 4 plazos sin intereses, con vencimiento cada 2 semanas."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Pagar con tarjeta"
							},
							"description": {
								"default": "Ofrece pagos als instante con tarjeta o transferencia bancaria."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "¿Cómo quieres vender?",
					"options": {
						"IN_STORE": "Tienda física",
						"TELESALES": "Ventas en remoto"
					},
					"description": {
						"IN_STORE": "Las ventas son principalmente presenciales y el cliente recibe los artículos al instante.",
						"TELESALES": "Las ventas son principalmente por teléfono, por llamadas entrantes de clientes. El cliente no recibe los artículos al instante."
					}
				},
				"country": {
					"label": "País"
				},
				"organization_category": {
					"label": "Tipo de persona jurídica",
					"options": {
						"SOLE_TRADER": "Empresario individual",
						"PARTNERSHIP": "Asociación",
						"UNDEFINED": "SIN DEFINIR",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "Corporación de tipo C",
						"S_CORP": "Corporación de tipo S",
						"TRUST_ESTATE": "Fideicomiso/patrimonio",
						"INDIVIDUAL": "Individual",
						"SOLE_PROPRIETORSHIP": "Titularidad unipersonal",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Sociedad de responsabilidad limitada unipersonal",
						"LIMITED_LIABILITY_COMPANY": "Sociedad de responsabilidad limitada",
						"PUBLIC_LISTED_COMPANY": "Empresa cotizada en bolsa",
						"PRIVATE_COMPANY": "EMPRESA_PRIVADA"
					}
				},
				"store_category": {
					"label": "Categoría principal de mercancías vendidas",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Ropa y calzado - Ropa y calzado para adultos",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Productos de automoción - Piezas y accesorios para la automoción",
						"BAGS_AND_WALLETS": "Joyería y accesorios - Bolsos y monederos",
						"BODY_AND_HAIR_CARE": "Salud y belleza - Cuidado del cuerpo y el cabello",
						"BOOK_AND_MAGAZINES": "Entretenimiento - Libros y revistas",
						"CANDY": "Alimentos y bebidas - Dulces",
						"CAR_ELECTRONICS": "Electrónica - Electrónica para vehículos",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Productos infantiles - Ropa y productos para la alimentación infantil",
						"CHILDREN_TOYS": "Productos infantiles - Juguetes",
						"CLEANING_AND_SANITARY": "Hogar y jardín - Limpieza e higienización",
						"COLLECTIBLES": "Ocio, deportes y aficiones - Coleccionables",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Ocio, deportes y aficiones - Tiendas de concepto y productos varios",
						"COSMETICS": "Salud y belleza - Cosméticos",
						"COSTUMES_AND_PARTY_SUPPLIES": "Ocio, deporte y aficiones - Disfraces y material para fiestas",
						"DATING_SERVICES": "Productos inmateriales - Servicios de citas",
						"DECORATION_AND_ART": "Hogar y jardín - Decoración y arte",
						"DIETARY_SUPPLEMENTS": "Salud y belleza - Suplementos dietéticos",
						"DIGITAL_SERVICES": "Productos inmateriales - Servicios digitales",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Productos infantiles - Productos infantiles varios",
						"DIVERSIFIED_ELECTRONICS": "Electrónica - Productos electrónicos varios",
						"DIVERSIFIED_ENTERTAINMENT": "Entretenimiento - Entretenimiento variado",
						"DIVERSIFIED_EROTIC_MATERIAL": "Material erótico - Material erótico variado",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Salud y belleza - Productos varios de salud y belleza",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Hogar y jardín - Productos varios de hogar y jardín",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Joyería y accesorios - Joyería y accesorios varios",
						"EDUCATION": "Productos inmateriales - Educación",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Electrónica - Equipos electrónicos y accesorios relacionados",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Material erótico - Prendas y accesorios eróticos",
						"EVENT_TICKETS": "Productos inmateriales - Entradas para eventos",
						"FOOD_AND_BEVERAGE": "Alimentación y bebidas - Alimentos y bebidas",
						"FRAGRANCES": "Salud y belleza - Fragancias",
						"FURNITURE": "Hogar y jardín - Muebles",
						"GENERAL_SHOES_AND_CLOTHING": "Ropa y calzado - Ropa y calzado en general",
						"HOBBY_ARTICLES": "Ocio, deporte y aficiones - Artículos para aficiones",
						"HOUSEHOLD_ELECTRONICS": "Electrónica - Electrónica del hogar",
						"JEWELRY_AND_WATCHES": "Joyería y accesorios - Joyas y relojes",
						"KITCHENWARE": "Hogar y jardín - Menaje de cocina",
						"MARKETPLACES": "Productos inmateriales - Mercados virtuales",
						"MUSIC_AND_MOVIES": "Entretenimiento - Música y cine",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Ocio, deporte y aficiones - Instrumentos y equipos musicales",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Joyería y accesorios - Gafas de sol y lentes no graduadas",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Electrónica - Aparatos de oficina y accesorios relacionados",
						"OTHER_SERVICES": "Productos inmateriales - Otros servicios",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Salud y belleza - Cuidados personales y tratamientos corporales",
						"PET_SUPPLIES": "Hogar y jardín - Productos para mascotas",
						"PHARMACEUTICAL_PRODUCTS": "Salud y belleza - Productos farmacéuticos",
						"PLANTS_AND_FLOWERS": "Hogar y jardín - Plantas y flores",
						"PRESCRIPTION_OPTICS": "Salud y belleza - Óptica de gafas graduadas",
						"PRINTS_AND_PHOTOS": "Ocio, deporte y aficiones - Impresión y fotografía",
						"SAFETY_PRODUCTS": "Hogar y jardín - Productos para la seguridad",
						"SEX_TOYS": "Material erótico - Juguetes sexuales",
						"SPORTS_GEAR_AND_OUTDOOR": "Ocio, deporte y aficiones - Material para deportes y actividades al aire libre",
						"TOBACCO": "Alimentación y bebidas - Tabaco",
						"TOOLS_AND_HOME_IMPROVEMENT": "Hogar y jardín - Herramientas y reformas del hogar",
						"TRAVEL_SERVICES": "Productos inmateriales - Servicios de viajes",
						"UNDERWEAR": "Ropa y calzado - Ropa interior",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entretenimiento - Videojuegos y accesorios relacionados",
						"WHEELS_AND_TIRES": "Productos de automoción - Ruedas y neumáticos",
						"WINE_BEER_AND_LIQUOR": "Alimentos y bebidas - Vino, cerveza y espirituosos",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Ropa y calzado - Ropa y calzado juveniles"
					}
				},
				"currency": {
					"label": "Moneda"
				},
				"account_type": {
					"label": "Tipo de cuenta bancaria",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Local de Suecia",
						"LOCAL_US": "Local de EE.UU.",
						"LOCAL_GENERIC": "Local de Noruega/Dinamarca",
						"SPECIAL": "Especial",
						"BANKGIRO": "Bankgiro local de Suecia",
						"PLUSGIRO": "Plusgiro local de Suecia"
					}
				},
				"person_role": {
					"label": "Cargo",
					"options": {
						"LEGAL_REPRESENTATIVE": "Representante legal",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Titular beneficiario opcional",
						"ULTIMATE_BENEFICIAL_OWNER": "Titular beneficiario en última instancia",
						"OWNER": "Titular"
					}
				},
				"business_size": {
					"label": "Tamaño de la empresa",
					"options": {
						"LARGE": "grande",
						"MEDIUM": "media",
						"small": "pequeña"
					}
				},
				"sensitive_good_category": {
					"label": "¿Ofreces alguno de los siguientes productos o servicios en tu tienda física?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Productos restringidos por razones de edad",
						"LICENSED_WEAPONS": "Armas con licencia",
						"PHARMA_AND_MEDICAL_SERVICES": "Sector farmacéutico y servicios médicos",
						"TRAVEL_TOURS_EVENTS": "Viajes, recorridos y eventos",
						"PEER_TO_PEER_MARKETPLACE": "Mercados entre pares",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Afiliaciones, suscripciones y servicios",
						"NONE": "Ofrezco otro tipo de producto/servicio"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabaco, cigarrillos electrónicos, vapeadores, productos de cannabis, alcohol, contenido para adultos",
						"LICENSED_WEAPONS": "Munición, cuchillos de combate, equipamiento de caza, porras, espray de pimienta",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribución de productos farmacéuticos con receta, procedimientos médicos incluidos de estética y tatuajes",
						"TRAVEL_TOURS_EVENTS": "Transporte, eventos, plataformas de entradas, hoteles o alojamiento, alquileres, agencias de viajes",
						"PEER_TO_PEER_MARKETPLACE": "Servicios que permiten a terceras partes revender sus productos u ofrecer servicios a través de su plataforma en línea",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Suscripciones a bienes físicos, contenido digital, servicios de streaming, sitios de citas, etc.",
						"NONE": "Ofrezco otro tipo de producto/servicio"
					},
					"error_message": "Lo sentimos. No podemos seguir procesando tu solicitud porque actualmente no admitimos el tipo de producto o servicio que has seleccionado."
				}
			},
			"common": {
				"country": {
					"label": "País"
				},
				"address": {
					"city": {
						"label": "Ciudad"
					},
					"postal_code": {
						"label": "Código postal"
					},
					"region": {
						"label": "Estado/región"
					},
					"street_address": {
						"label": "Dirección de tienda física"
					},
					"street_address2": {
						"label": "Línea de dirección 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Nombre de la empresa"
					},
					"registration_authority": {
						"label": "Autoridad responsable del registro"
					},
					"registration_id": {
						"label": "Número de inscripción en el registro"
					},
					"subject_to_vat": {
						"label": "¿Está registrada tu empresa a efectos de IVA?"
					},
					"vat_id": {
						"label": "Número de IVA"
					},
					"persons": {
						"date_of_birth": {
							"label": "Fecha de nacimiento"
						},
						"first_name": {
							"label": "Nombre"
						},
						"last_name": {
							"label": "Apellido"
						},
						"person_identity_document": {
							"label": "Documento de identidad"
						},
						"person_proof_of_address": {
							"label": "Comprobante de domicilio"
						},
						"personal_identifier": {
							"label": "Identificación personal"
						}
					},
					"should_auto_capture_orders": {
						"label": "¿Quieres capturar pedidos automáticamente?",
						"tooltip": "Los pedidos deben capturarse cuando se entregan en tienda física o cuando se envían desde un almacén. Al seleccionar la función de Autocaptura, el pedido se capturará automáticamente cuando el consumidor confirme la compra."
					}
				},
				"contract_entity": {
					"label": "Entidad contractual"
				},
				"contract_onboarding_type": {
					"label": "Tipo de integración de socio comercial"
				},
				"underwriting_inquiry_email": {
					"label": "Correo electrónico de suscripción"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Nombre del titular de la cuenta"
					},
					"account_number": {
						"label": "Número de cuenta"
					},
					"bic": {
						"label": "Código BIC"
					},
					"iban": {
						"label": "Número de cuenta (IBAN)"
					},
					"is_default": {
						"label": "Usa esta cuenta para divisas indeterminadas"
					},
					"routing_number": {
						"label": "Número de encaminamiento"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Correo electrónico de contacto"
					},
					"name": {
						"label": "Nombre de la tienda"
					},
					"support_email": {
						"label": "Correo electrónico de ayuda para el cliente"
					},
					"support_phone": {
						"label": "Número de teléfono de asistencia"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Venta tradicional de bienes",
							"VOUCHER": "Vale",
							"MEMBERSHIP": "Afiliación",
							"SUBSCRIPTION": "Suscripción",
							"PHARMACIES": "Farmacias",
							"US_PHARMACIES": "Farmacias de EE. UU.",
							"MEDICAL_SERVICES": "Servicios médicos",
							"MARKETPLACES": "Mercados virtuales",
							"FIREARM_DEALERS": "Venta de armas",
							"AUCTIONS": "Subastas",
							"ALCOHOL": "Alcohol",
							"TOBACCO": "Tabaco",
							"HEMP_CBD_THC": "Cáñamo, CBD o THC",
							"DONATIONS_CHARITY": "Donaciones y beneficencia",
							"TRAVEL": "Viajes",
							"EVENTS": "Eventos",
							"COURSES": "Cursos",
							"EDUCATIONAL_COURSES": "Cursos educativos",
							"FOOD_DELIVERY": "Entrega de alimentos",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Artículos personalizados bajo pedido/Muebles",
							"DIGITAL_CONTENT": "Contenido digital",
							"GAMING_INDUSTRY": "Industria del juego (juegos, apuestas, casinos, loterías)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Condiciones generales",
					"UPSELL_WEBSTORE_TO_KPOS": "Condiciones de Klarna en tienda física"
				},
				"pricing_terms": {
					"default": "Condiciones de precios",
					"UPSELL_WEBSTORE_TO_KPOS": "Precios de Klarna en tienda física"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Información adicional",
				"bank_account": "Indica los datos de tu cuenta bancaria",
				"business_size": "¿Cuál es tu previsión en cuanto a volumen anual a través del punto de venta de Klarna?",
				"in_store_get_started": "Lanza tu negocio con Klarna.",
				"in_store_legal_form": "¿Qué tipo de negocio tienes?",
				"in_store_registered_address": "¿Cuál es tu domicilio social?",
				"in_store_registration": "¿Es tu negocio una empresa registrada?",
				"in_store_stakeholder": "¿Quién dirige la empresa?",
				"in_store_stores": "¿Cuáles son los datos de tu tienda para el punto de venta de Klarna?",
				"in_store_vat": "¿Está registrada tu empresa a efectos de IVA?",
				"product_channel": "¿Cómo planea utilizar tu empresa el punto de venta de Klarna?",
				"sensitive_goods": "Qué categoría de productos venderás con el punto de venta de Klarna.",
				"ads_manager_get_started": "Ya casi hemos acabado.",
				"content_store_get_started": "Ya casi hemos acabado"
			},
			"subtitle": {
				"additional_data": "Estamos revisando tu solicitud y necesitamos algunos datos para poder proceder.",
				"bank_account": "Las transacciones de Klarna se transferirán a esta cuenta bancaria.",
				"business_size": "Necesitamos algunos datos básicos de tu empresa para tramitar tu solicitud.",
				"in_store_get_started": "Necesitamos algunos datos básicos para orientarte correctamente",
				"in_store_legal_form": "Tenemos la obligación de preguntar por algunos datos específicos en función de tu tipo de empresa.",
				"in_store_registered_address": "Se trata de la dirección donde tu empresa está registrada legalmente y la que consta en tus facturas de cliente de klarna.",
				"in_store_registration": "Necesitamos el número de registro de tu empresa para verificar los datos de tu negocio.",
				"in_store_stakeholder": "Como entidad financiera, debemos recopilar esta información",
				"in_store_stores": "Utilizaremos esta información para configurar tu nueva cuenta de punto de venta de Klarna.",
				"in_store_vat": "Si tienes un número de IVA podremos verificar más fácilmente tus datos corporativos.",
				"product_channel": "Elige tu principal canal de ventas. Podrás utilizar el punto de venta de Klarna para ambos canales.",
				"sensitive_goods": "El autoservicio de incorporación del punto de venta de Klarna no te permite vender artículos sujetos a restricciones por Klarna.",
				"ads_manager_get_started": "Proporciónanos un correo electrónico para enviar las facturas de la campaña. Debes tener permisos de usuario administrador para activar la cuenta; después podrás otorgar permisos a otros usuarios.",
				"content_store_get_started": "Antes de acceder a Content Manager, lee y acepta nuestras Condiciones generales."
			},
			"summary": {
				"title": "Antes de enviar la solicitud revisa tus datos"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Estamos procesando tu solicitud. Podría tardar un momento.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Espera, por favor...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Espera, por favor..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Tu solicitud se ha procesado y estamos creando tu nuevo ID de comercio."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Lo estamos preparando todo para tu cuenta de Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Estamos preparando tu cuenta de Gestor de contenidos."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "¡Enhorabuena! Tu solicitud se ha aprobado.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "¡Ya está todo a punto!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "¡Ya está todo a punto!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Ahora, vamos a integrar Klarna en tu tienda en línea. Dirígete a la pestaña “creación de marca” en tu cuenta del portal del comercio para encontrar tus credenciales de integración y las instrucciones sobre cómo usarlas."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Ahora vamos a configurar tu tienda para que empieces a recibir los pagos de inmediato."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Ve a Ads Manager y empieza a crear tu primera campaña."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Ve a Content Manager para publicar tu primera oferta hoy."
							}
						]
					},
					"second_title": {
						"default": "Consulta los documentos de Klarna para más información sobre cómo integrar Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "¿Necesitas ayuda para configurar tu tienda? Nosotros te ayudamos",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "¿Necesitas ayuda con Ads Manager? Consulta nuestras preguntas frecuentes o contacta con el servicio del soporte comercial y estaremos encantados de ayudarte.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "¿Necesitas ayuda con Content Manager? Consulta nuestras preguntas frecuentes o contacta con el servicio del soporte comercial y estaremos encantados de ayudarte."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Nuestras instrucciones sobre mejores prácticas pueden ayudarte a aprovechar al máximo tu nueva colaboración con nosotros."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Formas de pago",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Contacta con Ayuda al comercio y te echaremos una mano encantados."
							},
							{
								"text": "Contacta con el servicio de ayuda",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Consulta las preguntas frecuentes.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Consulta las preguntas frecuentes.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "¡Vamos!",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vamos",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vamos",
						"UPSELL_WEBSTORE_TO_KPOS": "Comienza a vender"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "¡Gracias! Se está revisando tu solicitud.",
					"badge": "De 5 a 7 días aprox.",
					"paragraphs": [
						{
							"text": "Recibirás un e-mail cuando hayamos completado la revisión o si necesitamos datos adicionales."
						}
					],
					"second_title": "Mientras tanto, revisa tu e-mail",
					"second_paragraphs": [
						{
							"text": "Te hemos enviado un e-mail con el siguiente enlace en el asunto: “Te damos la bienvenida al Portal del comercio de Klarna”. Sigue los pasos que te indicamos allí para iniciar sesión y activar tu cuenta."
						}
					]
				},
				"SUSPENDED": {
					"title": "Lo sentimos, tu solicitud no se ha aprobado.",
					"paragraphs": [
						{
							"text": "Tras haber revisado la información sobre tu empresa, no podemos seguir adelante con tu solicitud para <strong>{businessName}</strong>."
						},
						{
							"text": "A continuación puedes consultar algunas de las razones más frecuentes:"
						},
						{
							"list": [
								{
									"text": "Tu tienda no cumple con el código ético de Klarna."
								},
								{
									"text": "Tu servicio de atención al cliente no se encuentra localizable."
								},
								{
									"text": "Otros factores administrativos."
								}
							]
						},
						{
							"text": "Gracias por tu interés en <strong>Klarna [en tienda física]</strong> Esperamos poder colaborar en el futuro."
						}
					],
					"second_title": "Si tienes más dudas",
					"second_paragraphs": [
						{
							"text": "Relativas a nuestra decisión o a cualquier otro producto de Klarna, puedes ponerte en contacto con nosotros. Estaremos encantados de atenderte."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "¿Quién firma los contratos de tu empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Tu empresa se dispone a cerrar un contrato con Klarna. Debemos verificar quién tiene la autorización legal para firmar contratos."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "¿Alguna persona posee más del 25 % de la empresa?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
							}
						],
						"default": [
							{
								"text": "Necesitamos conocer a las personas que poseen más del 25 % de las acciones o los derechos de voto de la empresa o que ejercen un control similar. La directiva de la UE contra el blanqueo de capitales ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "¿Quién dirige la empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Es un requisito legal. En virtud de la directiva contra el blanqueo de capitales de la UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						],
						"US": [
							{
								"text": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
							}
						],
						"CA": [
							{
								"text": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
							}
						],
						"AU": [
							{
								"text": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "¿Alguna persona posee más del 25 % de la empresa?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Como entidad financiera tenemos la obligación legal de recopilar esta información."
							}
						],
						"default": [
							{
								"text": "Necesitamos conocer a las personas que poseen más del 25 % de las acciones o los derechos de voto de la empresa o que ejercen un control similar. La directiva de la UE contra el blanqueo de capitales ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") estamos obligados a recopilar esta información."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Soluciones",
					"title_2": "Formas de pago",
					"note": "Todos los precios son por transacción.",
					"per_transaction": "por transacción",
					"cross_border_notice": "Se pueden aplicar impuestos transfronterizos adicionales",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "consulta",
						"link_text": "el apéndice de precios"
					},
					"not_available_for_business": "No disponible para tu empresa",
					"not_available_for_country": "Solo puedes vender a otros mercados",
					"not_compatible_with_platform": "No disponible para tu plataforma",
					"installed": "Instalado"
				},
				"buttons": {
					"next": "Siguiente"
				}
			}
		}
	}
};